const languageEnObj = {
  "ra": {
    "action": {
      "send": "Send",
      "back_to_list": "Back to list",
      "clear": "Clear",
      "delete": "Delete",
      "eliminate": "Eliminate",
      "show": "Show",
      "list": "List",
      "save": "Save",
      "create": "Create",
      "edit": "Edit",
      "sort": "Sort",
      "cancel": "Cancel",
      "issuance": "Issuance",
      "undo": "Undo",
      "refresh": "Refresh",
      "retry_send": "Retry sending",
      "accounting_entry": "Accounting entry",
      "add": "Add",
      "remove": "Remove",
      "add_filter": "Add filter",
      "remove_filter": "Remove filter",
      "back": "Back",
      "bulk_actions": "%{smart_count} selected",
      "all": "All",
      "all_promotions": "All promotions",
      "export": "Export",
      "import": "Import",
      "unselect": "Unselect",
      "confirm": "Confirm",
      "add_specific": "Add %{name}",
      "clear_input_value": "Clear input value",
      "enable": "Enable",
      "disable": "Disable",
      "actions": "Actions",
      "generate_payment": "Generate payment",
      "search": "Search",
      "remove_all_filters": "Remove all filters",
      "go_payment_types": "Go to payment methods",
      "pay": "Pay",
      "authorize": "Authorize",
      "reconcile": "Reconcile",
      "reprocess_conciliation": "Reprocess conciliation",
      "reprocess_conciliation_item": "Reprocess",
      "adjust_cost_sale": "Adjust cost / sale",
      "force_reconcile": "Force reconcile",
      "unreconcile": "Do not reconcile",
      "delete_line": "Delete line",
      "generate_op": "Generate OP",
      "generate_invoice": "Generate invoice",
      "unauthorize": "Unauthorize",
      "to_confirm": "Confirm",
      "test_rule": "Test Rule",
      "see_details": "See details",
      "go_revision": "revisions",
      "clone": "Clone %{name}",
      "generate": "Generate",
      "generated": "Generated",
      "generate_receipts": "Generate receipts",
      "generate_receipt": "Generate receipt",
      "acept": "Accept",
      "emit": "Issue",
      "emit_status": "Issued",
      "cancel_status": "Canceled",
      "reimburse": "Reimburse",
      "refund": "Refund",
      "close": "Close",
      "see_conditions": "See conditions",
      "see_conditions_provider": "See provider conditions",
      "save_and_calculate_liquidation": "Save and calculate liquidation",
      "save_and_recalculate_liquidation": "Save and recalculate liquidation",
      "refresh_data": "Update data",
      "calculate_liquidation": "Calculate liquidation",
      "save_and_back_to_list": "Save and go back to the list",
      "create_reservation": "Create new reservation",
      "guarantee": "Guarantee",
      "move": "Move",
      "apply_to_reservation": "Apply to reservation",
      "apply_to_item": "Apply to items",
      "finish_and_generate_receipt": "Finish and generate receipt",
      "finish_without_generate_receipt": "Finish without generating receipt",
      "change_password": "Change password",
      "update": "Update",
      "see_something": "See %{thing}",
      "forward": "Forward",
      "forward_something": "Forward to %{something}",
      "continue": "Continue",
      "regenerate_notification": "Regenerate notification",
      "update_all_products": "Update all products",
      "add_file": "Add file",
      "initCompleteProcess": "Start Complete Process",
      "initProcess": "Init process",
      "preview": "Preview",
      "update_rule_view": "Update view",
      "finish": "Finish",
      "details": "Details",
      "split": "Split",
      "pay_with": "Pay with %{name}",
      "void": "Void",
      "select": "Select",
      "select_with_dots": "Select...",
      "loading": "Loading...",
      "loadingBusinessUnit": "Loading business units...",
      "loadingWorkUnit": "Loading work units...",
      "no_data": "No data",
      "filter": "Filter",
      "approve": "Approve",
      "refuse": "Refuse",
      "delete_business_in_tma": "Cancel business in TMA",
      "hidden": "hide",
      "addPaymentRecord": "Add payment record",
      "addAnotherPaymentRecord": "Add another payment record",
      "addNewRetention": "Add new retention",
      "removeRetention": "Remove retention",
      "deleteRecord": "Delete record",
      "addMoreReservations": "Add more reservations",
      "addReservations": "Add reservations",
      "registerPayment": "Register payment",
      "allocatePaymentToReservations": "Allocate payment to reservations",
      "searchReservations": "Search reservations",
      "downloadHistory": "Download history",
      "download": "Download",
      "download_file": "Download file",
      "addNewRelation": "Add a new relation",
      "addComponent": "Add component",
      "uploadAndReconcileStatement": "Upload and reconcile statement",
      "generateAndDownloadStatement": "Generate and download statement",
      "view_reservation": "View reservation",
      "add_comment": "Add comment",
      "unapply_payment": "Unapply payment",
      "after_sales": "After-sales",
      "complementary_item": "Complementary item",
      "create_item_supplier": "Supplier item",
      "show_aftersales": "Show after-sales item",
      "hide_aftersales": "Hide after-sales item",
      "register_return": "Register return",
      "view_retail_liquidation": "View retail liquidation",
      "new_message": "New message",
      "added": "added",
      "wrote": "wrote",
      "view_history": "View history",
      "general_search": "General search",
      "reply": "Reply",
      "return": "Return",
      "see_more": "See more...",
      "see_less": "Ver less",
      "generate_credit": "Generate credit",
      "add_reservation": "Add reservation",
      "enable_online_payments": "Enable online payments",
      "save_payment_instance": "Save payment instance",
      "add_payment_method": "Add payment method",
      "reliquidate": "Reliquidate",
      "disable_rebooker": "Disable rebooker",
      "apply_credits": "Apply credits",
      "generate_record": "Generate record",
      "delete_payments": "Delete payments",
      "menu": "Menu",
      "get": "Get",
      "query": "Query",
      "pricing": "Pricing",
      "revision": "Revision",
      "config": "Config",
      "full_edit_due_date": "Full edit due date",
      "optional": "Optional",
      "show_codes": "Show codes",
      "chatbot": "Chatbot",
      "save_without_validate": "Save without create relations",
      "copy_formula": "Copy formula",
      "copy_json": "Copy JSON",
      "paste_formula": "Paste formula",
      "update_receipt": "Update receipt",
      "view_cancel_supplier": "View Cancel Supplier",
      "generate_voucher": "Generate voucher",
      "download_voucher": "Download voucher",
      "as_item_create": "Create AS item in new reservation",
      "as_item_current_reserve": "Create AS item in this booking",
      "calculate_costs": "Calculate costs",
      "invalidate": "Void",
      "generate_on_demand": "Generate on demand",
      "archive": "Archive",
      "apply": "Apply"
    },
    "saved_queries": {
      "remove_label_with_name": "Remove query %{name}",
      "new_label": "Save current query",
      "search": "Search",
      "remove_all_filters": "Remove all filters",
      "go_revision": "revisions",
      "see_details": "See details",
      "test_rule": "Test"
    },
    "boolean": {
      "true": "Yes",
      "false": "No"
    },
    "page": {
      "list": "List of %{name}",
      "edit": "%{name} #%{id}",
      "show": "%{name} #%{id}",
      "create": "Create %{name}",
      "dashboard": "Dashboard",
      "not_found": "Not found",
      "loading": "Loading",
      "empty": "Empty Page",
      "invite": "Create the first record"
    },
    "input": {
      "file": {
        "upload_several": "Drag some files to start the upload, or click here to select them.",
        "upload_single": "Drag a file to start the upload, or click here to select it."
      },
      "image": {
        "upload_several": "Drag some images to start the upload, or click here to select them.",
        "upload_single": "Drag an image here to start the upload, or click here to select it."
      },
      "references": {
        "all_missing": "No references found.",
        "many_missing": "At least one of the associated references seems to be unavailable.",
        "single_missing": "The associated reference seems to be unavailable."
      },
      "password": {
        "toggle_hidden": "Show / Hide"
      },
      "placeholder": {
        "search": "Search..."
      }
    },
    "message": {
      "complete_required_fields": "Complete the required fields.",
      "please_select_field": "Please select %{field}",
      "separate_by_comma": "Separate values with comma",
      "disclaimer_billingform_all_amounts_are_expressed_value_selected_payment_currency_selected": "All amounts are expressed in the value of the selected payment currency.",
      "extract_download_available": "Extract download available.",
      "extract_download_error": "The extract does not exist in the database.",
      "select_file": "Select file...",
      "upload_only_xlsx_files": "Upload only .xlsx files",
      "upload_documents_create_reconciliation": "Upload documents to create reconciliation.",
      "select_fields_generate_extract_file": "Select fields to generate the extract file.",
      "route_config_import_description": "Upload a CSV file with the routes you want to configure. Each row must include the fields origin, destination, days_of_week, date_start and date_end.",
      "route_config_import_success": "Imported %{inserted} routes.",
      "route_config_import_partial": "Imported %{inserted} routes. %{errors} rows contain errors.",
      "route_config_import_error": "We could not import the file. Please try again.",
      "route_config_import_result": "Routes imported: %{inserted}. Errors: %{errors}.",
      "route_config_work_units_error": "We were unable to load the work units.",
      "route_config_product_types_error": "We were unable to load the product types.",
      "no_records_found": "No records found to export.",
      "no_records": "No records",
      "permissions_required": "Permissions are required to access.",
      "billingform_cancellation_warning": "If you are reporting payment for a reservation with upcoming or immediate cancellation, we recommend notifying the corresponding seller to guarantee the service. This module does not send automatic notifications to sellers.",
      "billingform_reservation_warning": "These values show the information recorded at the time the collection form was created and do not reflect the current status of the collection form.",
      "yes": "Yes",
      "no_registry": "No items loaded",
      "no_search_found": "No matches found",
      "yes_search_found": "Successful search",
      "no": "No",
      "are_you_sure": "Are you sure?",
      "about": "About",
      "not_found": "Page not found",
      "loading": "The page is loading, please wait a moment",
      "invalid_form": "The form is invalid, please correct possible errors",
      "delete_title": "Delete %{resource} %{name}",
      "delete_content": "Are you sure you want to delete this item?",
      "confirm_authorize": "Are you sure you want to authorize this payment order?",
      "confirm_unauthorize": "Are you sure you want to unauthorize this payment order?",
      "generate_client_title": "Generate client",
      "update_items_title": "Update items",
      "import_invoice_title": "Import invoice",
      "import_receipt_title": "Import receipt",
      "delete_invoice_title": "Delete invoice",
      "confirm_creation_sale_title": "Confirm creation business in TMA",
      "confirm_creation_sale_content": "Has the business been created correctly in TMA?",
      "confirm_add_items_title": "Confirm item addition in TMA",
      "confirm_add_items_content": "Have the items been added correctly in TMA?",
      "init_complete_process": "Start complete process",
      "generate_sale_title": "Generate business",
      "delete_sale_title": "Delete business",
      "add_items_title": "Add items",
      "generate_invoice_title": "Generate invoice",
      "generate_receipt_title": "Generate receipt",
      "generate_receipts_title": "Generate receipts",
      "cancel_receipt_title": "Cancel receipt",
      "delete_transaction_title": "Delete transaction",
      "delete_payment_reservation": "Delete payment",
      "confirm_action_content": "Are you sure you want to perform the action?",
      "bulk_delete_title": "Delete %{name} |||| Delete %{smart_count} %{name} items",
      "bulk_delete_content": "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      "unsaved_changes": "There are unsaved changes",
      "configuration": "%{name} configuration",
      "unmatch_amount_to_pay": "The total amount entered is not enough to pay the selected items",
      "reservation_item_not_found": "The reservation item was not found",
      "has_not_currencies_by_business_unit": "The selected work unit does not have available currencies, please select another one",
      "credit_in_favor_message": "The total amount of payments without additional costs equivalent to %{type_currency}  $ %{total_amount} is higher than the total amount of selected items %{type_currency} $ %{item_total_amount}, do you want the difference %{type_currency} $ %{rest_amount} to be recorded as \"payment on account\"?",
      "validate_amount_to_use": "The amount to use exceeds the total amount",
      "credit_in_favor_item_message": "The amount to pay %{currency} %{total_amount} is higher than the pending amount of the selected item  %{currency} %{item_total_amount}, do you want the difference %{currency} %{rest_amount} to be recorded as \"payment on account\"?",
      "all_route": "To not discriminate by any particular route, write the word \"all\".",
      "invalid_format": "The format is invalid",
      "format_route": "The route format must be like this \"XXX-XXX\", for example \"BUE-MIA\", \"CBA-MDA\"",
      "error_formula": "Sorry, there was a problem solving the formula! Please try again!",
      "number_input": "Priority increases as the number gets larger, 1 is the minimum priority and 100,000 is the maximum",
      "combine_formula_error": "The formula could not be combined with the parent rule formula",
      "cobine_formula_success": "The formula has been combined with the parent rule",
      "cobine_formula_remove": "The combination of the formula with the parent rule has been removed",
      "already_used": "%{name} is already in use",
      "desglose_var": "This variable will be shown in the breakdown",
      "desglose_rule_types_var": "This variable will be shown in the breakdown (%{ruleTypes})",
      "global_variable": "Global variable",
      "global_variable_and_show": "This global variable will be shown in the breakdown",
      "sitio_var": "This variable will be shown on the site",
      "desglose_and_sitio_var": "This variable will be shown on the site and in the breakdown",
      "desglose_rule_types_and_sitio_var": "This variable will be shown on the site and in the breakdown (%{ruleTypes})",
      "acept": "Accept",
      "cancel_item_reserva": "Are you sure you want to cancel this reservation %{reserva}?",
      "cancel_status_item_reserva": "Are you sure you want to change the reservation status %{reserva} to CANCELED?",
      "cancel_train_segment_reserva": "Are you sure you want to cancel this reservation %{reserva}?, The cost to pay for the cancellation will be %{currency} %{cost}",
      "delete_item_reserva": "Are you sure you want to delete the item %{item}?",
      "guarantee_item_reserva": "Are you sure you want to guarantee the item %{item}?",
      "cancel_item_segment": "Are you sure you want to cancel this segment %{segment}?, The cost to pay for the cancellation will be %{currency} %{cost}",
      "delete_item_segment": "Are you sure you want to delete this segment %{segment}?",
      "emit_item_reserva": "Are you sure you want to issue this reservation %{reserva}?",
      "emit_status_item_reserva": "Are you sure you want to change the reservation status %{reserva} to ISSUED?",
      "refresh_retrive_item_reserva": "Are you sure you want to update the reservation %{reserva}?",
      "rule_not_apply": "The %{rule} rule was not applied correctly",
      "error_create_item": "An error occurred while creating the product",
      "error_update_item": "An error occurred while editing the product",
      "success_create_item": "The product was created successfully",
      "success_edit_item": "The product was edited successfully",
      "delete_currency": "Are you sure you want to delete this currency? It will be permanently deleted",
      "delete_product": "Are you sure you want to delete this product? It will be permanently deleted",
      "delete_email": "Are you sure you want to delete this email? It will be permanently deleted",
      "delete_banner": "Are you sure you want to delete this banner? It will be permanently deleted",
      "delete_landing": "Are you sure you want to delete this landing? It will be permanently deleted",
      "delete_sector": "Are you sure you want to delete this sector? It will be permanently deleted",
      "integrity_error": "Could not delete because this record is part of another record",
      "total_payment_in": "Total to pay in ",
      "subtotal_in": "Subtotal in ",
      "filter_by_work_unit": "Filter by Work Unit",
      "filter_by_business_unit": "Filter by Business Unit",
      "filter_by_seller": "Filter by Seller",
      "export_success": "Request received, the file will be sent to the email %{email} shortly...",
      "export_error": "Error requesting data",
      "import_success": "The data has been imported successfully",
      "import_error": "Error importing data",
      "supplier_error": "Error requesting suppliers",
      "enter_data_manually": "Enter data manually",
      "retrieve_supplier_data": "Retrieve supplier data",
      "get_available_tickets": "Get available tickets",
      "change_password_title": "Change password",
      "invalid_password": "Invalid password",
      "no_have_credits": "You have no credits available",
      "reservation_found": "The reservation %{reservation_number} was found",
      "reservation_not_found": "The reservation %{reservation_number} was NOT found",
      "reservation_payment_generate_success": "The payment of the reservation  %{reservation_number} was successfully registered!",
      "reservation_payment_generate_error": "The payment of the reservation  %{reservation_number} was NOT registered!",
      "negative_amount_error": "The amount to be applied cannot be negative",
      "item_payment_generate_success": "Payment registered successfully.",
      "item_payment_generate_error": "Payment could not be registered.",
      "add_glosa_title": "Add text",
      "add_glosa_content": "Do you want to add text to the invoice?",
      "optional": "Optional",
      "non_refundable": "Non-refundable item",
      "always_cheapest": "Always the cheapest?",
      "transaction_detail_title": "Transaction detail",
      "sure_to_clone": "Are you sure you want to clone this %{entity}?",
      "rule_error": "Liquidation rule error",
      "clone_reservation": "Are you sure you want to clone this reservation %{reserva}?",
      "force_cancel": "There was an error in the cancellation, do you want to force the status change to CANCELED?",
      "invalid_cuit": "Incorrect CUIT entered",
      "valid_characters": "Enter at least %{num} characters to search",
      "error_to_delete_formula_global_variables": "Error deleting %{name}, you must first remove the variables from the following rules",
      "transaction_refund_success": "The transaction was successfully refunded.",
      "transaction_refund_error": "There was an error refunding the transaction",
      "capture_payment_success": "The payment was successfully captured.",
      "capture_payment_error": "There was an error capturing the payment.",
      "refund_transaction_title": "Refund transaction",
      "capture_payment_title": "Capture payment",
      "confirm_separation": "Are you sure to separate the passengers?",
      "ivalid_amount_passenger": "The total sum of the amount per passenger (%{passenger_amount}) exceeds the total payment amount (%{payment_type_amount})",
      "refresh_void_item_reserva": "Are you sure you want to void the reservation %{reserva}?",
      "not_found_imagen_size": "The image with the provided extensions was not found.",
      "field_to_calculate_liquidation": "To calculate the settlement, it is necessary to fill in the following fields: Source, Currency, Supplier, Supplier Net, Destination, Destination Type, and Service Start.",
      "delete_date_rate": "Are you sure you want to delete this date range? It will be permanently deleted.",
      "delete_due_date_method": "Are you sure to remove this expiration model? Will be permanently deleted",
      "has_no_children": "Has no children",
      "no_options_availble": "No options available",
      "no_passenger": "No passengers",
      "no_content_to_display": "No content to display",
      "email_sent_to": "Email sent to:",
      "product_value_assignment_text": "Enter the product JSON code in the *%{json_product}* field to load the *JSON* content. Select a data source in the *%{detail_table}* field to load the *tableName* content. Finally, select the values in the *JSON* table you want to associate in *tableName*, making the selection in the *tableName* value you want to assign it to.",
      "select_option": "Select an option:",
      "rule_formula_explantion": "To move formulas between pages, select the formula you want to move. Without releasing the formula, move the mouse to the page where you want to move it. The page will automatically change, and you will be able to position the formula in the desired location.",
      "select_at_least": "Select at least %{num} characters ",
      "enter_at_least": "Enter at least %{num} characters",
      "select_at_least_one_element": "Select at least one element",
      "instructive_work_unit_select": "*If you want to select multiple options, you can only select work units from the same level.",
      "instructive_paymen_type": "Pressing \"Add payment methods\" will allow you to select the type of payment you want to use.",
      "ref_site": "Reference name for the site",
      "approve_fraud": "Are you sure you want to pass the fraud review?",
      "refuse_fraud": "Are you sure you want to refuse of the fraud review?",
      "my_devices_duration_message": "You are logged in on these devices or have logged in to them in the last 30 days. Multiple sessions from the same device may appear.",
      "one_session_active": "1 session on a",
      "your_current_session": "Your current session",
      "logout_device": "Are you sure you want to remove this device %{device}?",
      "device_disabled_success": "The device was successfully removed!",
      "device_disabled_error": "There was an error removing the device.",
      "generates_multiple_receipt_success": "The receipt was generated correctly.",
      "generates_multiple_receipt_error": "There was an error generating the receipt.",
      "no_details_available": "No details available",
      "error_to_load_details": "There was an error loading details",
      "delete_business_TMA_message": "This action enables the items to be downloaded back to TMA",
      "delete_business_action_TMA_message": "This action cancels the business in TMA and the items it contains",
      "import_credit_note_title": "Import credit note",
      "generate_credit_note_title": "Generate credit note",
      "error_RUT": "RUT written incorrectly, must contain up to 12 characters",
      "error_CUIT": "CUIT incorrectly inserted",
      "number_exist": "The number entered already exists",
      "billing_error": "An error occurred while processing Billing",
      "success_payment_and_receipt_error": "The payment was recorded but the receipt failed",
      "paymentMethodNotConfigured": "This payment method has not been configured yet, please contact support.",
      "noFilesUploaded": "No files uploaded",
      "noReservationsSelected": "No reservations selected yet",
      "noOpenReservationsFound": "No open status reservations found",
      "enableFilter": "Enable the filter to list available open status reservations",
      "unavailable": "Unavailable",
      "noInformationAvailable": "No information available.",
      "completed": "Completed",
      "attention": "Attention",
      "confirmOrEditData": "You can now confirm the previously entered data or return to the form to make modifications.",
      "paymentRegisteredSuccess": "Payment successfully registered!",
      "paymentAppliedToReservations": "The payment has been successfully applied to the selected reservations",
      "paymentRegistrationError": "Error registering the payment",
      "tryAgain": "Please try again.",
      "noResultsAvailable": "No results available",
      "createRelationsBetweenCurrenciesAndBases": "You need to create the following relations between currencies and bases to continue",
      "beforeDeleting": "Before deleting",
      "deleteCurrencyBaseConfirmation": "Are you sure you want to delete this currency-base configuration?",
      "assignedMultipleTimesInRelationship": "it is assigned more than once in the relationship",
      "incompleteRelationshipBetween": "The relationship between is incomplete",
      "forTheRelationship": "For the relationship",
      "missingFollowingBases": "the following bases are missing",
      "theRelationshipBetween": "The relationship between",
      "noAssignedValue": "does not have an assigned value",
      "missingValuesForBases": "values need to be assigned to the bases",
      "changesAppliedSuccessfully": "Changes applied successfully, please run the save again",
      "paymentRegistrationExchangeRateError": "Cannot continue with the payment registration as there is no exchange rate available for the date ",
      "contactSupportMessage": "Please contact support.",
      "invalid_json": "Invalid JSON",
      "enter_json": "Enter the JSON",
      "copy_to_clipboard": "Copy to clipboard",
      "reservation_to_without_business": "The selected reservation does not have a business generated. Please generate a business for the selected reservation or choose another reservation to move the credits.",
      "reservation_from_without_business": "The current reservation does not have a business generated. Please generate a business for the current reservation to move the credits to another reservation.",
      "amount_exceeds_unused": "The amount exceeds the total amount of credits (%{amount_credit}).",
      "generate_provider_order": "Generation of Supplier Payment Order",
      "delete_comment": "Are you sure you want to delete this comment?",
      "amount_to_pay_error_min": "The sum of the amounts to be paid cannot be lesser than the total",
      "delete_requirement": "Are you sure you want to delete this requirement?",
      "delete_requirement_success": "Requirement deleted successfully",
      "delete_requirement_error": "An error occured while deleting the requirement",
      "view_refound_amount": "View refound penalty",
      "generate_supplier_payment_order": "Generate supplier payment order",
      "generate_client_payment_order": "Generate client payment order",
      "pending_amount_error": "Error: There is still pending balance to be allocated.",
      "allocation_amount_error": "Error: The allocation is greater than the amount paid.",
      "register_return": "Are you sure you want to register return of the item?",
      "assigned": "Assigned",
      "watched": "Watched",
      "created": "Created",
      "after_sales": "Are you sure you want to proceed with the after-sales service of the reservation %{reserva}?",
      "edit_notification_success": "Notification edited successfully",
      "edit_notification_error": "An error occurred while editing the notification",
      "delete_notification_confirm": "Are you sure you want to delete the notification?",
      "delete_notification_success": "Notification deleted successfully",
      "delete_notification_error": "An error occurred while deleting the notification",
      "change_status": "change status to %{status}",
      "change_status_error": "There was an error changing the reservation status",
      "added_reservation": "added reservation %{reservation}",
      "removed_reservation": "added reservation %{reservation}",
      "changed_subject": "updated the subject to \"%{subject}\"",
      "changed_description": "updated the description to \"%{description}\"",
      "assign_item": "assigned the item \"%{item}\"",
      "changed_type": "updated the type to \"%{type}\"",
      "file_added": "added the file \"%{file}\"",
      "file_removed": "removed the file \"%{file}\"",
      "and": "and",
      "updated_notification": "updated the notification",
      "notification_not_found": "Notification not found",
      "assigned_to": "assigned to %{user}",
      "changed_priority": "changed the priority from %{old_priority} to %{new_priority}",
      "add_notification": "%{user} added the notification",
      "notification_filter_error": "An error occured while filtering the notifications",
      "unapply_payment": "Are you sure you want to unapply the payment?",
      "unapply_payment_success": "Payment unapplied successfully",
      "unapply_payment_error": "An error occurred while unapplying the payment",
      "return_success": "Amount returned successfully",
      "return_error": "An error occurred while returning the amount",
      "payment_found": "The item can not be moved because it has an applied payment",
      "payment_found_delete": "The item can not be deleted because it has an applied payment",
      "update_status_error": "An error occured while updating the status",
      "changed_tracker_id": "changed tracker id to %{new_tracker_id}",
      "added_link": "changed reserves link %{new_link}",
      "credit_generated_success": "Credit generated successfully",
      "credit_generated_error": "The credit could not be generated",
      "due_tooltip": "Enable or disable this section to view only overdue bookings in the Reservation Details",
      "to_due_tooltip": "Enable or disable this section to view only upcoming bookings in the Reservation Details",
      "credits_tooltip": "Click here to go to the Credit Reservation Details",
      "unapply_confirmation": "Do you want to unapply transaction with an amount of %{currency} %{amount}?",
      "up_to_date": "You are up to date",
      "unapply_payment_item": "Do you want to unapply the payment applied to item %{description}?",
      "notification_redirect_error": "Notification associated with multiple reservations; it is not possible to use the shortcut to them. This will only be possible when the message is associated with a single reservation.",
      "amount_to_pay_error": "The sum of the amounts to be paid cannot be greater than the total",
      "open_status": "Are you sure you want to change the %{reserva} reservation status to OPEN?",
      "edit_report_success": "Report edited successfully",
      "edit_report_error": "There was an error editing the report",
      "create_report_success": "Report created successfully",
      "create_report_error": "There was an error creating the report",
      "confirmation_delete_paymentes_product": "Are you sure you want to delete the payment instances associated with the product %{product}?",
      "payment_product_decription": "Configure the payment instances per product",
      "payment_instance_deleted": "Payment instance successfully deleted",
      "payment_instance_delete_error": "There was an error deleting the payment instance",
      "every_day": "Every day",
      "amount_to_pay_requiered": "The amount to pay is required",
      "detailed_by_item": "Detailed by item",
      "general_detailed": "General detailed",
      "preconfigured": "Preconfigured",
      "on_demand_date": "On demand - By dates",
      "on_demand_reserve": "On demand - By reservation number",
      "on_demand": "On demand",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "yesterday": "Yesterday",
      "last_days": "Last 7 days",
      "current_week": "Current week",
      "last_week": "Last week",
      "current_month": "Current month",
      "last_month": "Last month",
      "current_quarter": "Current quarter",
      "previous_quarter": "Previous quarter",
      "current_year": "Current year",
      "last_year": "Last year",
      "year_to_date": "Year to date",
      "month_to_date": "Month to date",
      "week_to_date": "Week to date",
      "unique": "Unique",
      "commercial": "Commercial",
      "payment_allocation": "Payment allocation",
      "reserve_control": "Reservation control",
      "journal_entry_control": "Journal entry control",
      "accounting_control": "Accounting control",
      "confirm_delete_report": "Are you sure you want to delete the report %{name}?",
      "scheduled": "Scheduled",
      "summarized": "Summarized",
      "uniqueDateValidation": "Tomorrow is the first available date for sending \"Preconfigured\" reports. Create an \"On-demand\" report if you need to receive it now.",
      "onDemandDateAclaration": "The maximum analysis period for 'On-demand - By dates' reports is 2 months.",
      "reliquidation_error": "There was an error during reliquidation",
      "reliquidation_confirm": "Are you sure you want to execute the reliquidation %{liquidation}?",
      "delete_items_title": "Delete items",
      "disable_rebooker_confirmation": "Are you sure you want to disable the rebooker?",
      "collection": "Payment",
      "supplier": "Supplier",
      "sales": "Sales",
      "account_state": "Account state",
      "smartbook": "Smartbook",
      "metasearch": "Metasearch",
      "reservation_B2C": "Reservations",
      "client": "Client",
      "delete_chat_bot": "Are you sure you want to delete the entire conversation? This action is irreversible.",
      "confirmation_apply_credits": "Are you sure you want to apply all the reservation credits to your items?",
      "confirm_delete": "Yes, delete",
      "update_confirmation": "Are you sure you want to update the information?",
      "hepstar": "Hepstar",
      "undefined": "Undefined",
      "init_process_confirmation": "Are you sure you want to start the process?",
      "client_tooltip": "Select from the list the Client you want to log in with",
      "client_change_confirmation": "Are you sure you want to switch clients?",
      "no_history": "No history available",
      "delete_payments_message": "Are you sure you want to delete the payments?",
      "commercial_detail": "Commercial detail",
      "billing_mexico": "Billing Mexico",
      "auto_bill_odoo_condition": "Automatic Billing in Odoo",
      "auto_bill_guaranteed_odoo": "Automatic Land Billing of Guaranteed Items in Odoo",
      "auto_bill_b2c_condition": "Automatic B2C Billing",
      "auto_bill_condition": "Automatic Billing",
      "auto_bill_guaranteed_condition": "Automatic Billing of Guaranteed Items",
      "auto_bill_isbillable_condition": "Automatic Billing of Items Ready to Bill",
      "auto_bill_land_condition": "Automatic Land Billing",
      "auto_bill_payment_condition": "Automatic Billing of Paid Items",
      "auto_create_billing_condition": "Automatic Item Creation",
      "auto_create_land_condition": "Automatic Land Item Creation",
      "auto_create_with_is_billable": "Automatic Creation of Items Ready to Bill",
      "no_client_mirror": "There is no mirror for this client",
      "on_demand_logs": "On demand - Logs",
      "preconfigured_logs": "Preconfigured - Logs",
      "on_demand_account_state": "On demand - Account state",
      "preconfigured_account_state": "Preconfigured - Account state",
      "external_account_state": "External account state",
      "permission_tooltip": "Hover over the permission to see its description",
      "accrued_billing_mexico": "Accrued Billing México",
      "delete_condition_confirmation": "Are you sure you want to delete the condition?",
      "new_after_sales_item_confirmation": "Are you sure you want to create a after-sale item in a new booking?",
      "delete_bank_extract": "Are you sure you want to delete the bank transaction?",
      "pending_business_unit": "Pending Business Unit Assignment to Reservation",
      "invalid_amount": "Invalid amount",
      "invalidate_document": "Are you sure you want to void the document?",
      "select_product_type_report": "Select a product type to generate a report",
      "reliquidation_error_rule": "Failed recalculation. No applicable rule found",
      "autocomplete_field": "It completes automatically",
      "select_supplier_to_search": "Select a supplier to view available items",
      "invalidate_provision": "Confirm the cancellation of the following provision?",
      "delete_file_message": "Are you sure you want to delete the attachment?",
      "max_characters": "Maximum length: %{characters} characters",
      "complementary_item_success": "Complementary item created successfully.",
      "complementary_item_error": "Error creating complementary item.",
      "no_item_to_link_complementary": "No valid item found to link the complementary item.",
      "multiple_email_separated_comma": "Allows adding more than one email, separated by commas without spaces",
      "installment_import_error_details_title": "Import error details",
      "installment_import_error_line": "Line %{line}",
      "installment_import_error_field": "Field \"%{field}\": %{error}",
      "approve_debin": "Are you sure you want to approve the Debin transaction?",
      "refuse_debin": "Are you sure you want to reject the Debin transaction?"
    },
    "navigation": {
      "no_results": "No results found",
      "no_results_filters": "No results found. Try changing filters.",
      "no_more_results": "Page number %{page} is out of bounds. Try the previous page.",
      "page_out_of_boundaries": "Page number %{page} is out of bounds",
      "page_out_from_end": "Cannot navigate past the last page",
      "page_out_from_begin": "Cannot navigate before page 1",
      "page_range_info": "%{offsetBegin}-%{offsetEnd} of %{total}",
      "page_range_info_billingform": "%{page} of %{totalPages}",
      "next": "Next",
      "prev": "Previous",
      "page_rows_per_page": "Rows per page",
      "skip_nav": "Skip",
      "of": "Of",
      "page": "Page"
    },
    "auth": {
      "username": "Username",
      "user_menu": "User",
      "password": "Password",
      "login": "Log in",
      "sign_in_error": "Authentication error, please try again",
      "sign_in": "Sign in",
      "logout": "Log out",
      "forbidden": "Your session has expired, please log in again",
      "auth_check_error": "You need to be logged in to access this view",
      "recover_password": "Recover password",
      "recover_password_success": "An email has been sent to recover the password",
      "badrequest": "Request error",
      "unauthorized": "Authorization error",
      "unknown": "Server error",
      "device_not_found": "You have logged in from a new device. Please check your email and enter the code.",
      "sign_in_to_different_account": "Sign in to a different account",
      "device_code_invalid": "The code is not valid. Please enter it again.",
      "device_code_missing": "Please check your inbox to validate access.",
      "device_code": "Verification code",
      "check_your_inbox": "Check your inbox",
      "enter_device_code": "We have sent a secure access link to %{mail} so you can log in again.",
      "user_disabled": "You have exceeded the number of attempts, you must reset your password to continue",
      "device_code_expired": "The code has expired. A new one will be sent, please check your email.",
      "device_with_expired_session": "The session has expired. Please check your email and enter the code.",
      "reset_password": "You have exceeded the number of attempts. For security, we have changed your password, and you can view it in your email.",
      "download_export_success": "File exported sucessfully.",
      "username_exists": "The username is already in use."
    },
    "status": {
      "CANCELLED": "CANCELED",
      "CANCELED": "CANCELED",
      "CANCELLED_COST": "CANCELED WITH COST",
      "USED": "USED",
      "CANCEL_PROVIDER": "CANCELED BY PROVIDER",
      "PENDING": "PENDING ISSUANCE",
      "PENDING_BILLING": "PENDING",
      "CONFIRMED": "CONFIRMED",
      "INVOICED": "ISSUED",
      "NOT_INVOICED": "NOT ISSUED",
      "REFUNDED": "REFUNDED",
      "PARTIAL_REFUND": "PARTIALLY REFUNDED",
      "OPEN": "OPEN",
      "CLOSED": "CLOSED",
      "DELETED_FEM": "DELETED",
      "EXPIRED": "EXPIRED",
      "EXPIRED_MALE": "EXPIRED",
      "REFUND_IN_PROGRESS": "REFUND IN PROGRESS",
      "INVOICE_IN_PROGRESS": "ISSUANCE IN PROGRESS",
      "INVOICE_REQUESTED": "ISSUANCE REQUESTED",
      "CANCELLATION_IN_PROGRESS": "CANCELLATION IN PROGRESS",
      "VOID_IN_PROGRESS": "VOID IN PROGRESS",
      "PROCESSING": "ISSUANCE IN PROCESS",
      "PAID": "PAID",
      "UNPAID": "UNPAID",
      "PARTIALLY_PAID": "PARTIALLY PAID",
      "NOT_REQUIRED": "NOT REQUIRED",
      "GUARANTEED": "GUARANTEED",
      "IN_REVIEW": "IN REVIEW",
      "REJECTED": "REJECTED",
      "REJECTED_MALE": "REJECTED",
      "PENDING_RESERVATION": "PENDING RESERVATION",
      "VOID": "VOID",
      "REINVOICED": "REISSUED",
      "PARTIAL_INVOICED": "ISSUED PARTIAL",
      "DELETED": "DELETED",
      "CREATED": "CREATED",
      "null": "-",
      "undefined": "UNDEFINED",
      "ISSUED": "ISSUED",
      "PREBOOKED": "PREBOOKED",
      "BILLED": "BILLED",
      "SENT": "SENT",
      "NOT REQUIRED": "NOT REQUIRED",
      "IN RSV": "IN RESERVATION",
      "DEFEATED": "EXPIRED",
      "DUE": "DUE",
      "ERROR": "ERROR",
      "TO_BILLING": "TO INVOICE",
      "APPROVED": "APPROVED",
      "MANUALLY_APPROVED": "MANUALLY APPROVED",
      "MANUALLY_DISAPPROVED": "MANUALLY DISAPPROVED",
      "FRAUD_ANALYSIS": "FRAUD ANALYSIS",
      "DUE_TODAY": "DUE TODAY",
      "status_entered": "Entered",
      "status_review": "Review",
      "status_rejected": "Rechazado",
      "status_aproved": "Aprobado",
      "status_aproved_partially": "Partially approved",
      "ON_SITE": "ON SITE",
      "PENDING_OPERATION": "OPERATIONS",
      "INIT_CHECKOUT": "REQUEST CREATED",
      "open": "Open",
      "open_fem": "Open",
      "closed": "Closed",
      "closed_fem": "Closed",
      "processing": "In Process",
      "deleted": "Deleted",
      "deleted_fem": "Deleted",
      "reconciled": "Reconciled",
      "completed": "Completed",
      "completed_fem": "Completed",
      "CROSSELL_SELECTED": "CROSSELL REQUEST",
      "FLIGHT_BOOKING_COMPLETED": "FLIGHT CREATED",
      "FRAUD_REVITION": "FRAUD UNDER REVIEW",
      "PAYMENT_IN_PROCESS": "PAYMENT IN PROCESS",
      "SESSION_EXPIRED": "SESSION EXPIRED",
      "CASH_PAYMENT_ABANDONED": "CASH PAYMENT ABANDONED",
      "BOOKING_REJECTED": "BOOKING FAILED",
      "PAYMENT_REJECTED": "PAYMENT FAILED",
      "FRAUD": "FRAUD",
      "PAID_WITHOUR_FEE": "PAID WITHOUT FEE",
      "CASH_PAYMENT": "CASH PAYMENT",
      "NOT_AVAILABILITY": "DISPONIBILITY ERROR",
      "PREBOOKING_FAILED": "PREBOOKING FAILED",
      "RESERVED": "RESERVED",
      "DUPLICATED": "DUPLICATED",
      "IN_PROCESS": "IN PROCESS",
      "FAILED_INVOICED": "FAILED INVOICE",
      "FINALIZED": "FINALIZED",
      "FINISHED": "FINISHED",
      "AFTER_SALES": "AFTER-SALES",
      "AFTER_SALES_HIDDEN": "AFTER-SALES",
      "CREDIT_GENERATED": "CREDIT GENERATED",
      "CREDIT_NOT_GENERATED": "CREDIT NOT GENERATED",
      "CREDIT_APPLIED": "CREDIT APPLIED",
      "UNAPPLIED": "UNAPPLIED",
      "APPLIED": "APPLIED",
      "PARTIALLY_APPLIED": "PARTIALLY_APPLIED",
      "CONFIRMED_UNAPPLIED": "CONFIRMED-",
      "PRE-RESERVATION": "PRE-RESERVATION",
      "ON_REQUEST": "ON REQUEST",
      "REQUESTED": "REQUESTED",
      "IN_PROGRESS": "IN PROGRESS",
      "AVAILABLE": "AVAILABLE",
      "PAGO": "PAID",
      "PENDIENTE_EMISION": "PENDING",
      "EMITIDO": "INVOICED",
      "SOLICITUD_EMISION": "ISSUANCE REQUESTED",
      "EMISION_FALLIDA": "FAILED INVOICE",
      "INVALIDATED": "INVALIDATED",
      "GENERATED": "GENERATED",
      "UNDEFINED": "NOT DEFINED",
      "active": "ACTIVE",
      "inactive": "INACTIVE",
      "SESSION_CLOSED": "SESSION CLOSED",
      "DUPLICATED_RECOVERED": "DUPLICATED - RECOVERED"
    },
    "title": {
      "filters": "Filters",
      "create_user": "Create a user",
      "update_user": "Edit a user",
      "create_entity": "Create an entity",
      "update_entity": "Edit an entity",
      "create_tag": "Create a Tag",
      "update_tag": "Edit a Tag",
      "create_role": "Create a role",
      "update_role": "Edit a role",
      "create_processApplication": "Create a process by application",
      "update_processApplication": "Edit a process by application",
      "create_process": "Create a process by module",
      "update_process": "Edit a process by module",
      "create_permission": "Create a permission",
      "update_permission": "Edit a permission",
      "create_module": "Create a module",
      "update_module": "Edit a module",
      "create_client": "Create a client",
      "update_client": "Edit client",
      "create_application": "Create an application",
      "update_application": "Edit an application",
      "create_businessType": "Create a business type",
      "update_businessType": "Edit a business type",
      "create_businessUnit": "Create a business unit",
      "update_businessUnit": "Edit a business unit",
      "create_country": "Create a country",
      "update_country": "Edit a country",
      "create_currency": "Create a currency",
      "create_type_responsible": "Create responsible type",
      "update_type_responsible": "Edit responsible type",
      "update_currency": "Edit a currency",
      "create_documentType": "Create a document type",
      "update_documentType": "Edit a document type",
      "create_product": "Create a product",
      "update_product": "Edit a product",
      "create_workUnit": "Create a work unit",
      "update_workUnit": "Edit a work unit",
      "create_bank": "Create Bank Account",
      "update_bank": "Update Bank Account",
      "create_businessRule": "Create a business rule",
      "list_item_to_pay": "List of items to pay",
      "route_config_import": "Import routes",
      "route_config_export": "Export routes",
      "item_selected": "Selected items",
      "item_total": "Total items",
      "edit_item_supplier": "Edit item",
      "create_item_supplier": "Create supplier item",
      "update_payment_type": "Edit Payment Type",
      "create_payment_type": "Create a Payment Type",
      "credit_in_favor": "Credit in favor",
      "general_information": "General Information",
      "update_sale": "Edit sale",
      "update_supplier": "Edit supplier",
      "update_reservation": "Edit reservation",
      "update_source": "Edit source",
      "general": "General",
      "products": "Products",
      "add_product": "Add product",
      "client": "Client",
      "passenger": "Passengers",
      "passengers": "Passengers",
      "add_passenger": "Add passenger",
      "update_passenger": "Edit passenger",
      "aerial": "Flight",
      "reserve_information": "Reservation information",
      "contanct": "Contact",
      "observations": "Observations",
      "aerial_information": "Flight information",
      "segments": "Segments",
      "segment": "Segment",
      "add_segment": "Add another segment",
      "delete_segment": "Delete segment",
      "going": "GOING",
      "return": "RETURN",
      "departure": "Departure",
      "arrival": "Arrival",
      "scale": "Scale",
      "duration": "Duration",
      "luggage": "Luggage",
      "wait_in": "Wait at the",
      "hotel": "Hotel",
      "car": "Car",
      "air": "Air",
      "other": "Others",
      "train": "Train",
      "flight": "Flight",
      "others": "Others",
      "other_product": "Product (Others)",
      "train_segment": "Trains Ticket",
      "train_passes": "Trains passes",
      "billing": "Billing",
      "hotel_information": "Hotel information",
      "liquidation": "Liquidation",
      "contact": "Contact",
      "transfer_information": "Transfer information",
      "service_information": "Service information",
      "date": "Dates",
      "direct": "Direct",
      "provider_info": "Provider data",
      "tags": "Tags",
      "rooms": "Rooms",
      "people_by_room": "person (s) x1 Room.",
      "cancellation_cost": "Cancellation costs",
      "cancellation_cost_provider": "Provider cancellation costs",
      "cancellation_cost_client": "Client cancellation costs",
      "car_information": "Car information",
      "trip_car_information": "Trip information",
      "train_information": "Train information",
      "customer_file": "Customer file",
      "total_duration": "Total Duration",
      "formula": "Formula",
      "edit_businessRule": "Edit Rule",
      "solve_formula": "Resolved Formula",
      "pay_condition": "Payment conditions",
      "credits": "Credits",
      "credit_against": "balance to pay",
      "pending_items": "Pending items",
      "items_to_bill": "Items to be billed",
      "generated_invoices": "Generated invoices",
      "actions": "Actions",
      "payment": "Payment",
      "transactions": "Transactions",
      "pricing": "Price Breakdown",
      "liquidation_retail": "Retail liquidation",
      "liquidation_supplier": "Supplier liquidation",
      "liquidation_wholesaler": "Wholesaler liquidation",
      "transfer": "Transfer",
      "create_cash": "Create cash",
      "update_cash": "Edit cash",
      "contact_emergency": "Emergency contact",
      "assistance_information": "Assistance information",
      "assistance": "Assistance",
      "re_assign": "Reassign %{entity}",
      "update_contact": "Update contact",
      "update_liquidation": "Update Liquidation",
      "update_card": "Update card",
      "create_card": "Create card",
      "update_pricing": "Edit origin values",
      "complementary_item": "New complementary item",
      "update_productType": "Edit product type",
      "create_productType": "Create product type",
      "update_variable": "Edit Variable",
      "condition": "Conditions",
      "tickets": "Tickets",
      "exchange_type": "Exchange rate",
      "exchange_types": "Exchange rates",
      "recalculate_liquidation_rule": "Which of the following liquidations do you want to recalculate?",
      "empty": "There are no %{some}",
      "update_numbering": "Edit numbering",
      "create_numbering": "Create numbering",
      "create_source": "Create source",
      "last_sales": "Last Sales",
      "air_tickets": "Air Tickets %{name}",
      "select_client_and_app": "Select the client and the application",
      "sales_with_pending_payment": "Sales with pending payment",
      "pending_payment": "Pending payment",
      "pending_voucher": "Pending voucher",
      "autocancel": "Auto cancellation",
      "pending_confirmation": "Pending confirmation",
      "notification": "Notifications",
      "update_payment_method": "Edit payment method",
      "create_payment_method": "Create payment method",
      "sales_with_paid_payment": "Sales with paid payment",
      "sales_with_guaranteed_payment": "Sales with guaranteed payment",
      "reservations_to_pay": "Reservations to pay",
      "see_items": "See items",
      "item_balances": "Item balances",
      "reservation_credit": "Reservation credits",
      "send_email": "Send email",
      "regenerate_notification": "Generate new notification and send email",
      "files": "Files",
      "file": "File",
      "files_uploaded": "Uploaded files",
      "file_name": "File name",
      "create_bannerType": "Create banner type",
      "update_bannerType": "Edit banner type",
      "create_banner": "Create banner",
      "update_banner": "Edit banner",
      "create_ext_train_marketing_carrier": "Create marketing carrier",
      "update_ext_train_marketing_carrier": "Edit marketing carrier",
      "sectors": "Sectors",
      "create_landing": "Create landing",
      "update_landing": "Edit landing",
      "preview_landing": "Landing preview",
      "compensation_credit": "Credit Compensation",
      "update_transaction": "Edit transaction",
      "payment_register": "Payment Registration",
      "addButton": "Add button",
      "update_eticket": "Edit E-ticket",
      "update_date": "Modify date",
      "create_due_date_method": "Create expiration model",
      "update_due_date_method": "Update expiration model",
      "create_due_date_range": "Create due date range",
      "update_due_date_range": "Update Due Date Range",
      "update_pricing_passenger": "Update passenger origin values %{passenger}",
      "update_exchange_type": "Edit Exchange Type",
      "product_value_assignment": "Product value assignment",
      "update_financial_entity": "Update Financial Entity",
      "create_custom_var": "Create Custom Variable",
      "select_exist_label": "Select an Existing Label",
      "select_work_unit": "Select a work unit",
      "create_company": "Create company",
      "update_company": "Update company",
      "create_financial_entity": "Create Financial Entity",
      "update_operation_type": "Update Operation type",
      "create_operation_type": "Create Operation type",
      "update_due_date": "Update payment due date",
      "my_devices": "My devices",
      "credits_applied": "Credits applied",
      "credit_applied_detail": "Credit destination",
      "payment_info": "Payment information",
      "paymentRecord": "Payment Record",
      "reservationsToPaySelection": "Selection of reservations to pay",
      "reservationSelection": "Reservation selection",
      "selectedReservations": "Selected reservations",
      "selectReservations": "Select reservations",
      "reservationItems": "Reservation items",
      "requestConfirmation": "Request confirmation",
      "totals": "Totales",
      "applicant": "Applicant",
      "paymentDetails": "Payment details",
      "exchangeRateHistory": "Exchange rate history",
      "labelReceiptAndImputation": "Receipt and allocation",
      "history": "History",
      "trip_info": "Trip information",
      "client_data": "Client Data",
      "fraud_info": "Fraud information",
      "customer_data": "Customer data",
      "create_commerce_number": "Create Commerce Number",
      "update_commerce_number": "Update Commerce Number",
      "create_gateway": "Create Payment Gateway",
      "update_gateway": "Update Payment Gateway",
      "move_credit_reservation": "Move credits",
      "payment_order_requirement": "Request for payment order",
      "create_installment": "Create installment",
      "update_installment": "Edit installment",
      "import_installment": "Indicate the financing sheet you wish to import",
      "operations_required_action": "Operational table - Action required",
      "emited_without_fee": "Emited without fee",
      "failed_emit": "Failed emission",
      "pending_payment_cash": "Pending payment - Cash",
      "pending_billing": "Pending billing",
      "transactions_resume": "(Today's date) Transaction summary",
      "in_site": "On site",
      "reserved": "Reserved",
      "cancelled": "Canceled",
      "error": "Error",
      "issued": "Issued",
      "share_by_status": "Share by state",
      "share_by_cancelation_type": "Share by type of cancellation",
      "cancelled_by_fraud": "Canceled due to fraud",
      "cancelled_by_failed_payment": "Cancelled due to failed payment",
      "cancelled_by_failed_booking": "Cancelled due to failed booking",
      "cancelled_by_payment_cash": "Cash payment canceled",
      "cancelled_by_expired_session": "Canceled due to expired session",
      "general_conditions": "General conditions",
      "fee_conditions": "Fee conditions",
      "user_agent": "User agent",
      "last_login": "Last login",
      "suppliers_actions": "Suppliers actions",
      "reserve_requirement": "Reservation requirements",
      "clients_actions": "Clients actions",
      "price_history": "Price history",
      "origin_values": "Origin values",
      "returns": "Returns",
      "code_edit": "Edit codes",
      "update_status": "Update status",
      "balances": "Balances",
      "how_much_to_pay": "How much do I have overdue and need to pay today?",
      "weekly_due_dates": "Weekly due dates",
      "debt_per_period": "Debt pero period",
      "detail_per_reservation": "Detail per reservation",
      "last_payments": "Latest payments",
      "whith_balances": "Debit balance",
      "with_credits": "Credit balance",
      "balance_to_pay": "Balance to pay",
      "edit_report": "Edit report",
      "scheduled_reports": "Scheduled reports",
      "generated_reports": "Generated reports",
      "credits_data": "Credit details",
      "noDataAvailable": "No data available",
      "billing_number": "Enter the item number for invoicing:",
      "balance_transfer_received": "Received Balance Transfers",
      "balance_transfer_sent": "Sent Balance Transfers",
      "confirm_action": "Confirm action",
      "generate_business_items": "Generate Business + Items",
      "clients": "CLIENTS",
      "suppliers": "Suppliers",
      "supplier": "Supplier",
      "registers": "Registers",
      "register": "Register",
      "edit_config": "Edit configuration",
      "user_information": "User information",
      "create_ext-air-airline": "Create airline",
      "update_ext-air-airline": "Edit airline",
      "commercial_documents": "Commercial documents",
      "items": "Items",
      "services": "Services",
      "color_reference": "Color reference",
      "document_data": "Document details",
      "create_billing": "Create invoice",
      "update_billing": "Edit invoice",
      "voucher_details": "Voucher details",
      "invoice_already_exists": "The item you entered already exists on an invoice",
      "delete_file": "Delete attachment",
      "create_supplier": "Create supplier",
      "basic_data": "Basic data",
      "fiscal_data": "Fiscal data",
      "configuration": "Configuration",
      "create_base": "Create base",
      "update_base": "Edit base",
      "create_supplier_conciliation": "New conciliation",
      "supplier_conciliation_detail": "Conciliation detail",
      "supplier_conciliation": "Conciliation",
      "supplier-conciliation": "Conciliation",
      "preview": "Preview",
      "promotions": "Promotions",
      "flexi": "Flexi",
      "flexiRate": "Flexible Rate",
      "servicePackage": "Service Package",
      "extra_baggage": "Extra Baggage",
      "coupon_data": "COUPON DATA",
      "discount_type_amount": "DISCOUNT TYPE AND AMOUNT",
      "create_promotion": "Create promotion",
      "update_promotion": "Edit promotion",
      "pending_hepstar": "Hepstar Pending"
    },
    "notification": {
      "noRoleApplication": "No roles found for the selected application",
      "noPermissionApplication": "No permissions found for the selected application",
      "noApplicationClient": "No applications found for the selected client",
      "clientsNotFound": "No clients found",
      "updated": "Element updated |||| %{smart_count} elements updated",
      "created": "Element created",
      "deleted": "Element deleted |||| %{smart_count} elements deleted",
      "bad_item": "Incorrect item",
      "item_doesnt_exist": "The item does not exist",
      "http_error": "Communication error with the server",
      "currency_or_supplier_missing": "Currency or Supplier parameter is missing",
      "due_date_required": "Due date is required",
      "no_supplier_items_to_generate_invoice": "No supplier items found to generate the invoice",
      "canceled": "Action canceled",
      "error_updated": "Sorry, we could not update the Element %{smart_count}",
      "data_provider_error": "Sorry, there was a problem with the data provider",
      "no_static_json": "No default JSON found",
      "created_success_masculine": "The %{element} has been created successfully",
      "created_success_femenine": "The %{element} has been created successfully",
      "created_error_masculine": "The %{element} has not been created",
      "created_error_femenine": "The %{element} has not been created",
      "create_invoice_process_error_in_conciliation": "An error occurred during the process. Manually verify invoice creation",
      "updated_success_masculine": "The %{element} has been updated successfully",
      "updated_success_femenine": "The %{element} has been updated successfully",
      "updated_error_masculine": "The %{element} has not been updated",
      "updated_error_femenine": "The %{element} has not been updated",
      "deleted_success_masculine": "The %{element} has been deleted successfully",
      "deleted_success_femenine": "The %{element} has been deleted successfully",
      "deleted_error_masculine": "The %{element} has not been deleted",
      "deleted_error_femenine": "The %{element} has not been deleted",
      "authorized_success": "Payment order authorized successfully",
      "unauthorized_success": "Payment order unauthorized successfully",
      "retry_supplier_billing_success": "Supplier billing invoice sending was retried successfully",
      "retry_supplier_billing_error": "Could not retry sending the supplier billing invoice",
      "canceled_item_reserve_success": "The Reservation %{reserve} was canceled",
      "cancellation_in_progress": "The reservation %{reserve} will be canceled shortly",
      "canceled_item_reserve_error": "The Reservation %{reserve} was NOT canceled",
      "delete_item_error": "The item %{item} was NOT deleted",
      "delete_item_success": "The item %{item} was deleted",
      "emit_status_item_success": "The item %{item} was issued",
      "emit_status_item_error": "The item %{item} was NOT issued",
      "cancel_status_item_success": "The item %{item} was canceled",
      "cancel_status_item_error": "The item %{item} was NOT canceled",
      "guarantee_item_success": "The item %{item} was guaranteed",
      "guarantee_item_error": "The item %{item} was NOT guaranteed",
      "move_item_success": "The item %{item} was moved",
      "move_item_error": "The item %{item} was NOT moved",
      "complementary_item_success": "Complementary item created successfully",
      "complementary_item_error": "Error creating complementary item",
      "emit_item_reserve_success": "The issuance of the reservation %{reserve} was requested",
      "emit_item_reserve_error": "The issuance of the reservation %{reserve} was NOT requested %{reason}",
      "emit_item_fail_reserve_error": "There was an error, The reservation %{reserve} was NOT issued",
      "retrive_item_reserve_success": "The reservation %{reserve} was updated",
      "retrive_item_reserve_error": "There was an error, The reservation %{reserve} was NOT updated",
      "refund_segment_item_reserve_success": "The segment %{segment} was refunded",
      "refund_segment_item_reserve_error": "The segment %{segment} was NOT refunded",
      "delete_segment_item_reserve_success": "The segment %{segment} was deleted",
      "delete_segment_item_reserve_error": "The segment %{segment} was NOT deleted",
      "updated_success_passenger": "The passenger %{passenger} has been updated successfully",
      "updated_success_titular": "The passenger %{passenger} is now the holder",
      "updated_error_titular": "The passenger %{passenger} could not be updated",
      "updated_success_business_unit": "The client has been updated to %{client}",
      "updated_error_business_unit": "The client could not be updated",
      "add_success_passenger": "The passenger %{passenger} was added successfully",
      "add_error_passenger": "The passenger could not be added",
      "success_full_process": "The complete process has been completed successfully",
      "error_full_process": "The complete process has not been completed",
      "created_success_sale_reservation": "Business generated successfully",
      "created_error_sale_reservation": "The business could not be generated",
      "deleted_success_sale_reservation": "Business deleted successfully",
      "deleted_error_sale_reservation": "The business could not be deleted",
      "deleted_success_invoice_reservation": "Invoice deleted successfully",
      "deleted_error_invoice_reservation": "The invoice could not be deleted",
      "created_success_add_items_reservation": "Items added successfully",
      "created_error_add_items_reservation": "The items could not be added",
      "updated_error_items_success": "The items have been updated successfully",
      "updated_error_items_error": "The items have NOT been updated",
      "updated_success_contact": "The Contact %{contact} has been updated",
      "add_tag_success": "The tag was added",
      "add_tag_error": "The tag was NOT added",
      "remove_tag_error": "There was a problem deleting the tag",
      "updated_error_contact": "The Contact could not be updated",
      "updated_success_pricing": "The price has been updated",
      "updated_error_pricing": "The price could not be updated",
      "updated_success_seller": "The Seller has been updated",
      "updated_error_seller": "The Seller could not be updated",
      "updated_success_liquidation": "The liquidation has been updated",
      "updated_error_liquidation": "The liquidation could not be updated",
      "liquidation_rule_invalid": "The variables are hidden or the rule was not loaded correctly",
      "check_extra_cost": "Please ensure that all extra costs were calculated",
      "error_retrieve": "There was an error retrieving the supplier data",
      "error_loading_products": "There was an error loading the products",
      "change_password_success": "The password has been changed successfully",
      "change_password_error": "The password has NOT been changed",
      "forward_email_to_success": "The email was sent to %{email_to}",
      "forward_email_to_error": "An error occurred while sending the email, please try again later",
      "regenerate_notification_to_success": "The notification has been generated successfully",
      "regenerate_notification_to_error": "An error occurred while generating the notification, please try again later",
      "create_error_banner_by_work_unit": "The banners could not be added to the work unit",
      "create_error_banner_by_business_unit": "The banners could not be added to the business unit",
      "update_error_banner_by_work_unit": "The banners of the work unit could not be updated",
      "update_error_banner_by_business_unit": "The banners of the business unit could not be updated",
      "upload_image_error": "An error occurred while uploading the image",
      "clone_item_success": "The item %{item} was cloned",
      "clone_item_error": "The item %{item} was NOT cloned",
      "aftersales_item_success": "The after-sales service for item %{item} was created",
      "aftersales_item_error": "The after-sales service for item %{item} was NOT created",
      "error_update_view": "There was an error trying to update the view.",
      "already_update_view": "The view was recently updated, please try again later.",
      "success_update_view": "The view was updated.",
      "applied_credit_success": "Credit applied successfully!",
      "applied_credit_error": "There was an error applying the credit",
      "update_transaction_success": "The transaction was updated successfully!",
      "update_transaction_error": "There was an error updating the transaction",
      "currency_not_found_in_business_unit": "The currency %{currency} does not exist in the list of currencies of the business unit",
      "currency_exchange_not_found": "There is no exchange rate for %{currency}.",
      "pnr_used": "The PNR was already imported or does not exist",
      "splited_item_reserve_error": "There was an error trying to separate the passengers",
      "splited_item_reserve_success": "Successful separation!",
      "void_item_reserve_success": "The reservation %{reserve} was voided successfully!",
      "void_item_reserve_error": "There was an error trying to void the reservation %{reserve}",
      "due_date_success": "The date was successfully updated!",
      "due_date_error": "There was an error trying to update the date.",
      "update_error_date_range": "There was an error trying to update the date range.",
      "create_error_date_range": "There was an error trying to create the date range.",
      "delete_error_date_range": "There was an error trying to delete the date range.",
      "delete_success_date_range": "The date range was successfully deleted!",
      "delete_error_due_date_method": "An error occurred while trying to delete the due date method",
      "delete_success_due_date_method": "The due date method was successfully deleted!",
      "approve_fraud_item_reserve_success": "Fraud analysis passed successfully",
      "approve_fraud_item_reserve_error": "Fraud analysis could not be passed",
      "refuse_fraud_item_reserve_success": "Fraud analysis was successfully rejected",
      "refuse_fraud_item_reserve_error": "Fraud analysis could not be rejected",
      "relationshipDeletedSuccess": "Relationship successfully deleted",
      "errorDeletingRelationship": "Error deleting the relationship",
      "transfer_credit_success": "The credits were transferred successfully!",
      "transfer_credit_error": "There was an error transferring credits",
      "no_gateway_options": "There is no gateway option enabled",
      "generate_order_success": "Payment order was generated successfully",
      "generate_order_error": "There was an error generating the payment order",
      "unapply_payment_success": "Payment successfully voided.",
      "unapply_payment_error": "The payment could not be voided.",
      "register_return_success": "The item %{item} was returned",
      "register_return_error": "The item %{item} was NOT returned",
      "edit_codes_error": "The codes could not be updated",
      "report_deleted_success": "The report was successfully deleted",
      "report_deleted_error": "There was an error deleting the report",
      "credit_updated_success": "Credit updated successfully",
      "credit_updated_error": "Credit not updated",
      "delete_error_items_success": "The items have been successfully deleted",
      "delete_error_items_error": "The items were NOT deleted",
      "disable_rebooker_success": "Rebooker disabled successfully",
      "disable_rebooker_error": "Rebooker was NOT disabled",
      "send_question_error": "There was an error sending the question",
      "apply_credits_success": "The credits were applied successfully",
      "apply_credits_error": "There was an error applying the credits",
      "edit_business_number_success": "Business number edited successfully",
      "edit_business_number_error": "There was an error editing the business number",
      "updated_notifications_success": "The notifications were updated successfully",
      "updated_notifications_error": "There was an error updating the notifications",
      "max_chars_prompt": "Your question cannot exceed 1000 characters in length",
      "invoice_generated_success": "The invoice has been created successfully",
      "invoice_generated_error": "There was an error creating the invoice",
      "journal_entry_generated_success": "The journal entry has been created successfully",
      "journal_entry_generated_error": "An error occurred while creating the journal entry",
      "provision_generated_success": "The provision has been created successfully",
      "provision_generated_error": "An error occurred while creating the provision",
      "invalidate_provision_success": "The provision has been invalidated successfully",
      "invalidate_provision_error": "An error occurred while invalidating the provision",
      "order_generated_success": "The payment order has been created successfully",
      "order_generated_error": "There was an error creating the payment order",
      "delete_paymente_success": "Payments deleted successfully",
      "delete_paymente_error": "There was a problem deleting the payments",
      "wait_data_loading": "Please wait for all data to load",
      "error_loading_work_units": "Error: Could not load work units",
      "error_loading_destination_types": "Error: Could not load destination types",
      "error_loading_currencies": "Error: Could not load currencies",
      "error_select_work_unit": "Error: You must select a work unit",
      "error_currency_not_available": "Error: The selected currency is not available",
      "error_work_units_not_available": "Error: Work units data is not available",
      "error_currencies_not_available": "Error: Currencies data is not available",
      "error_work_unit_id_not_found": "Error: Could not get the ID of the selected work unit. Please select the work unit again.",
      "error_currency_id_not_found": "Error: Could not get the ID of the selected currency. Please select the currency again.",
      "mirror_edit_success": "Mirror edited successfully",
      "mirror_edit_error": "There was an error editing the mirror",
      "formula_copy_success": "Formula copied successfully",
      "formula_copy_error": "There was an error copying the formula",
      "formula_paste_success": "Formula pasted successfully",
      "formula_paste_error": "There was an error pasting the formula",
      "edit_extract_success": "Bank statement successfully edited",
      "edit_extract_error": "There was an error editing the bank statement",
      "edit_receipt_success": "Receipt edited successfully",
      "edit_receipt_error": "There was an error editing the receipt",
      "update_receipt_success": "Receipt updated successfully",
      "update_receipt_error": "There was an error updating the receipt",
      "different_bases_error": "The bases of the selected reserves do not match",
      "voucher_not_found": "There is no voucher configuration associated with this product",
      "voucher_error": "Error generating voucher for this item",
      "delete_condition_success": "The condition was successfully deleted",
      "delete_condition_error": "There was an error deleting the condition",
      "after_sales_item_success": "The post-sale item was created successfully",
      "after_sales_item_error": "The post-sale item could not be created",
      "edit_variables_success": "Variables edited successfully",
      "edit_variables_error": "There was an error editing the variables",
      "edit_item_supplier_success": "The item was edited successfully",
      "edit_item_supplier_error": "There was an error editing the item",
      "create_item_supplier_success": "The supplier item was created successfully",
      "create_item_supplier_error": "There was an error creating the supplier item",
      "delete_extract_success": "The bank transaction was deleted successfully",
      "delete_extract_error": "There was an error deleting the bank transaction",
      "inactive_business_unit": "The Business Unit was deactivated because it could not be deleted",
      "generate_credite_note_success": "Credit note generated successfully",
      "generate_credite_note_error": "Unable to generate the credit note",
      "invalidate_document_success": "Document successfully voided",
      "invalidate_document_error": "An error occurred while voiding the document",
      "refetch_data_error": "An error occurred while updating the document",
      "visualize_invoice_error": "There was an error previewing the data",
      "upload_file_error": "There was an error uploading the file",
      "conciliation_process_started": "Conciliation file received and processing started (ID: %{id})",
      "conciliation_process_error": "Error starting conciliation processing",
      "export_conciliation_items_scheduled": "The report is being processed. You will receive an email.",
      "please_select_field": "Please select %{field}",
      "delete_file_success": "The file has been successfully deleted",
      "delete_file_error": "Error deleting the file"
    },
    "validation": {
      "required": "Required",
      "minLength": "Must be at least %{min} characters",
      "maxLength": "Must be %{max} characters or less",
      "minValue": "Value must be greater than %{min}",
      "maxValue": "Value must be less than %{max}",
      "number": "Must be a number",
      "email": "Must enter a valid email",
      "oneOf": "Must be one of the following values: %{options}",
      "regex": "Must follow a specific format (regexp): %{pattern}",
      "date_invalid": "Please enter a valid date",
      "date_min": "Please enter a greater date",
      "date_max": "Please enter a lesser date",
      "noOptionsText": "No options",
      "minCharacters": "Enter at least two characters to search",
      "time_invalid": "Please enter a valid time",
      "maxCharacters": "You exceeded the maximum characters, must be less than %{characters}",
      "fieldIsRequired": "This field is required",
      "errorCreatingBases": "It seems there was an error creating the bases. Please check that all fields are complete.",
      "errorCreatingBasesValues": "It seems there was an error creating the bases. The relationship values must be greater than 0.",
      "errorCreatingBasesUniqueCombinations": "It seems there was an error creating the bases. The combinations of source currency, target currency, and base must be unique.",
      "missingFields": "Required fields are missing",
      "noSpaces": "No spaces allowed"
    },
    "tooltiptext": {
      "rule_type_first": "You must first select the rule type"
    },
    "modules": {
      "authentication": "Authentication",
      "administration": "Administration",
      "marketing": "Content Management",
      "sales": "Sales",
      "payment": "Payments",
      "setup": "Setup",
      "rules": "Rules",
      "purchases": "Purchases",
      "billing": "Purchases"
    },
    "single_entity": {
      "application": "application",
      "client": "client",
      "module": "module",
      "permission": "permission",
      "process": "process by module",
      "processApplication": "process by application",
      "role": "role",
      "user": "user",
      "business-type": "business type",
      "business-unit": "business unit",
      "country": "country",
      "currency": "currency",
      "document-type": "document type",
      "product-type": "product type",
      "product": "product",
      "work-unit": "work unit",
      "business-rule": "business rule",
      "entity": "entity",
      "payment-entity": "payment",
      "installment": "installment",
      "card": "card",
      "source": "source",
      "bank": "bank",
      "expenses": "expense",
      "operation-type": "operation type",
      "cash": "cash",
      "company": "company",
      "financial-entity": "financial entity",
      "type-responsible": "responsible type",
      "payment-type": "payment type",
      "payment-method": "payment method",
      "type_responsible": "type of responsible",
      "reservation": "reservation",
      "supplier": "supplier",
      "tag": "tag",
      "banner-type": "banner type",
      "banner": "banner",
      "ext-train-marketing-carrier": "marketing carrier",
      "landing": "landing",
      "formula-global-variables": "global formula variable",
      "due-date-method": "Expiration model",
      "date-range": "Payment Due Date",
      "due-date-range": "Payment Due Date",
      "gateway": "Payment Gateway",
      "commerce-number": "Commerce Number",
      "operation": "operation",
      "route-config": "route configuration",
      "supplier-billing": "invoice",
      "supplier-payment-order": "payment order",
      "operation-bff": "BFF operation",
      "ext-air-airline": "Airline",
      "supplier-conciliation": "conciliation",
      "bases": "bases",
      "base": "Base",
      "promotion": "promotion",
      "invoice": "Billing"
    },
    "entity": {
      "bilingform_conciliation": "Conciliations",
      "bilingform_extracts": "Extracts",
      "billingform": "Payment form",
      "child_entities": "Children",
      "sales": "Sales",
      "otherModule": "Other module",
      "config_application": "Application configurations",
      "work-unit": "Work Unit",
      "business-unit": "Business Unit",
      "currency": "Currency",
      "document-type": "Document Type",
      "product-type": "Product Type",
      "country": "Country",
      "product": "Product",
      "business-type": "Business Type",
      "reservation": "Reservation",
      "air-detail": "Air Detail",
      "hotel-detail": "Hotel Detail",
      "user": "User",
      "role": "Role",
      "permission": "Permissions",
      "client": "Client",
      "application": "Application",
      "process": "Processes by Module",
      "processApplication": "Processes by Application",
      "module": "Module",
      "userByClientApp": "User of the application-client",
      "permissionByUser": "User permissions",
      "applicationByClient": "Client application",
      "permissionByRole": "Role permissions",
      "item": "Item",
      "supplier": "Supplier",
      "contact": "Contact",
      "roleByUser": "User role",
      "user-by-business-unit": "User by Business Unit",
      "product-work-unit-by-business-unit": "Work Unit Product by Business Unit",
      "car-detail": "Car Detail",
      "user-by-work-unit": "User by Work Unit",
      "currency-by-business-unit": "Currency by Business Unit",
      "currency-by-work-unit": "Currency by Work Unit",
      "pax": "Passenger",
      "fiscal-data": "Fiscal data",
      "cancel-info": "Cancellation information",
      "cancel-info-item": "Reservation cancellation information",
      "product-by-work-unit": "Product by Work Unit",
      "pax-item": "Reservation passenger",
      "billing": "Billing",
      "business-rule": "Business rules",
      "entity": "Entity",
      "installment": "Financing",
      "card": "Cards",
      "source": "Source",
      "bank": "Bank",
      "payment-type": "Payment type",
      "payment-method": "Payment method",
      "expenses": "Expenses",
      "operation-type": "Operation type",
      "cash": "Cash",
      "company": "Company",
      "financial-entity": "Financial Entity",
      "versions": "Versions",
      "type-responsible": "Responsible Type",
      "numbering": "Numbering",
      "payment-entity": "Payments",
      "tag": "Tag",
      "banner-type": "Banner Type",
      "banner": "Banner",
      "ext-train-marketing-carrier": "Marketing Carrier",
      "landing": "Landing",
      "userB2": "User",
      "formula-global-variables": "Global formula variables",
      "due-date-method": "Expiration model",
      "due-date-range": "Expiration Schedule",
      "financial_entity": "Financial entity",
      "my-devices": "My devices",
      "operation": "Operations",
      "commerce-number": "Commerce No.",
      "gateway": "Payment Gateway",
      "notification": "Notifications",
      "account-state": "State account",
      "reporting": "Reporting",
      "route-config": "Routes",
      "supplier-billing": "Invoices",
      "supplier-payment-order": "Payment orders",
      "operation-bff": "BFF Operations",
      "item-supplier": "Supplier Account State",
      "devices-by-user": "Devices by user",
      "account-transfer": "Account transfer",
      "baggage-options": "Baggage options",
      "promotion-coupon": "Promotion coupon",
      "supplier-billing-item": "Supplier billing item",
      "supplier-payment-order-item": "Supplier payment order item",
      "payment-order-detail": "Payment order detail",
      "payment-cash": "Payment cash",
      "payment-online": "payment online",
      "userPaym": "User payment",
      "work-unitPaym": "Work unit payment",
      "cash-detail": "Cash detail",
      "payment-method-by-work-unit": "Payment method by work unit",
      "payment-type-by-work-unit": "Payment type by work unit",
      "article": "Article",
      "clientBilling": "Client billing",
      "itemBilling": "Item billing",
      "voucher": "Voucher",
      "air-rule-detail": "Air rule detail",
      "car-rule-detail": "Car rule detail",
      "destination-type": "Destination type",
      "hotel-rule-detail": "Hotel rule detail",
      "item-rule": "Item rule",
      "payment-detail": "Payment detail",
      "rule-type": "Rule type",
      "static-json": "Static json",
      "other-detail": "Other detail",
      "air_tickets": "Air tickets",
      "air-import": "Air import",
      "sourcePayment": "Source Payment",
      "ext-air-airline": "Airlines",
      "invoice": "Billing",
      "supplier-conciliation": "Conciliation",
      "bases": "Base",
      "promotion": "Promotions"
    },
    "field": {
      "departure": "Departure",
      "arrival": "Arrival",
      "segment": "Segment",
      "first_name": "First Name",
      "last_name": "Last Name",
      "date_of_birth": "Date of Birth",
      "doc_type": "Document Type",
      "doc_number": "Document Number",
      "country_of_residence": "Country of Residence",
      "email_address": "Email Address",
      "extract_file": "Extract file",
      "include_deleted": "Include deleted",
      "total_records": "Total records",
      "reconciled": "Reconciled",
      "not_found": "Not found",
      "with_differences": "With differences",
      "date_from": "Date from",
      "date_to": "Date to",
      "xls_file": "XLS File",
      "required_columns_info": "Required columns: LOCATOR, VALUE",
      "xls_xlsx_file": "XLS/XLSX File",
      "drag_file_here": "Drag the file here or",
      "select_file_button": "Select file",
      "file_format_info": "Only .xls or .xlsx · Max. 10 MB",
      "supplier_value": "Supplier Value",
      "b2_value": "B2 Value",
      "difference_value": "Difference",
      "difference": "Difference",
      "conciliation_air": "Air",
      "conciliation_land": "Land",
      "has_invoice": "Has invoice",
      "is_paid": "Is paid",
      "short_reservation_number": "Nro. reserva",
      "ut": "UT",
      "seller": "Seller",
      "actions": "Actions",
      "status": "Status",
      "status_b2": "Status B2",
      "invoiced": "Issued",
      "code": "Code",
      "date": "Date",
      "currency": "Currency",
      "locator": "Locator",
      "supplier": "Supplier",
      "total_reconciled": "Total reconciled",
      "general_status": "Status",
      "aftersales_destination": "After-sales destination",
      "same_reservation": "Same reservation",
      "new_reservation": "New reservation",
      "adjustment_type": "Adjustment",
      "cost_only": "Cost only",
      "cost_and_sale": "Cost and sale",
      "clickable_stats_help": "↑ Each value is clickable and filters the table",
      "showing_all": "Showing: all records",
      "showing_reconciled": "Showing: reconciled lines",
      "showing_not_found": "Showing: not found lines",
      "showing_differences": "Showing: lines with differences · ordered from highest to lowest",
      "showing_unreconciled": "Showing: unreconciled lines",
      "unreconciled": "Not reconciled",
      "no_records": "No records to show",
      "rows_per_page": "Rows per page",
      "states_legend": "Statuses:",
      "actions_legend": "Actions:",
      "reconciled_legend": "Reconciled (automatic)",
      "reconciled_adjusted_legend": "Reconciled by adjustment",
      "reconciled_manually_legend": "Manually reconciled",
      "reconciled_duplicate_legend": "Previously reconciled",
      "difference_legend": "With difference",
      "not_found_legend": "Not found",
      "unreconciled_legend": "Not reconciled",
      "deleted_legend": "Deleted",
      "total_deleted": "Deleted",
      "op_generated_from_conciliation": "Payment order generated from Conciliation #%{id}",
      "generate_op_success": "Payment order successfully generated",
      "auto_adjustment_legend": "Auto adjustment",
      "cost_sale_adjustment_legend": "Cost/sale adjustment",
      "delete_line_legend": "Delete line",
      "confirm_unreconcile_title": "Confirm Not reconciled",
      "confirm_unreconcile_msg": "Are you sure you want to mark this item as \"Not reconciled\"?",
      "confirm_delete_title": "Confirm line deletion",
      "confirm_delete_msg": "Are you sure you want to delete this line from the conciliation?",
      "confirm_retry_title": "Confirm conciliation retry",
      "confirm_retry_msg": "Are you sure you want to retry conciliation for the selected items? (%{count})",
      "confirm_retry_all_msg": "Are you sure you want to retry conciliation for all items? (%{count})",
      "retry_scheduled_success": "Conciliation retry process scheduled in background",
      "aftersales_success": "After-sales action generated successfully",
      "reservations": "Reservations",
      "retentions": "Retentions",
      "certificate": "Certificate",
      "payers_document_number": "Payer document number",
      "coupon_number": "Coupon number",
      "download_receipts": "Download receipts",
      "download_extract": "Download extract",
      "observations": "Observations",
      "observations_internal": "Internal observations",
      "inputation_type": "Inputation type",
      "inputation_amount": "Inputation amount",
      "amount_aboned": "Subscribed amount",
      "select_all": "all...",
      "created_until": "Date until",
      "created_from": "Date from",
      "undefined": "undefined",
      "include": "Include",
      "exclude": "Exclude",
      "choices": "Choices",
      "chosen": "Chosen",
      "selected": "selected",
      "status_flow": "Flow status",
      "pass_name": "Product",
      "pass_validity": "Validity",
      "pass_duration": "Duration",
      "pass_offer_type": "Offer Type",
      "pass_marketing_carrier": "Marketing Carrier",
      "product": "Product",
      "products": "Products",
      "total_reservation": "Total Reservation",
      "products_inheritance": "Inherited Products",
      "products_inheritance_ut": "Inherited Work Unit Products",
      "products_inheritance_un": "Inherited Business Unit Products",
      "dashboard": "Dashboard",
      "is_offline": "Is offline",
      "children": "Children",
      "adults": "Adults",
      "minors": "Minors",
      "layout": "Template",
      "state": "Status",
      "zip_code": "Zip Code",
      "id": "Id",
      "token": "Token",
      "token_parent": "Parent Token",
      "email": "Email",
      "short_name": "Short name",
      "long_name": "Long name",
      "business_type": "Business type",
      "business_type_id": "Business type Id",
      "name": "Name",
      "phone": "Phone",
      "phone_number": "Phone number",
      "address": "Address",
      "region": "Region",
      "document_type": "Document type",
      "document_type_id": "Document type ID",
      "document_number": "Document number",
      "type_responsible": "Responsible type",
      "manager_responsible": "Operational Responsible",
      "commercial_responsible": "Commercial Responsible",
      "birthday": "Date of Birth",
      "description": "Description",
      "item_description": "Item description",
      "contact": "Contact",
      "administrative_contact": "Administrative contact",
      "fantasy_name": "Fantasy name",
      "date_out": "Departure date",
      "date_in": "Arrival date",
      "symbol": "Symbol",
      "color": "Color",
      "ref_table_detail": "Detail table",
      "create_at": "Created",
      "updated_at": "Updated",
      "update_at": "Updated",
      "work_unit": "Work Unit",
      "work_unit_id": "Work Unit Id",
      "business_unit": "Business unit",
      "firstname": "Name",
      "surname": "Last name",
      "application": "Application",
      "client": "Client",
      "role": "Role",
      "hash_user": "User hash",
      "status_detail": "Status",
      "action": "Action",
      "module": "Module",
      "entity": "Entity",
      "application_id": "Application Id",
      "start_icon": "Start icon",
      "permission": "Permissions",
      "menu": "Menu",
      "text": "Text",
      "is_active": "Active",
      "is_not_active": "Inactive",
      "is_superadmin": "Superadmin",
      "is_staff": "Staff",
      "is_admin": "Admin",
      "module_id": "Module Id",
      "client_id": "Client Id",
      "product_json": "Product JSON",
      "start_validity_rule": "Rule Start Validity",
      "expiration": "Expiration",
      "config": "Configuration",
      "end_validity_rule": "Rule End Validity",
      "username": "Username",
      "user_id": "User Id",
      "user": "User",
      "password": "Password",
      "value": "Value",
      "tax_id": "Tax Identifier",
      "date_in_and_out": "Departure and arrival date",
      "endpoint": "Endpoint",
      "steps": "Steps",
      "flight_number": "Flight number",
      "airline": "Airline",
      "hotel": "Hotel",
      "item_id": "Item Id",
      "id_detail": "Detail Id",
      "parameters": "Parameters",
      "country_id": "Country Id",
      "country": "Country",
      "countries": "Countries",
      "date_emision": "Date emision",
      "city": "City",
      "currencies": "Currencies",
      "currency_inheritance": "Inherited currency",
      "code_iata": "Code IATA",
      "tma_code": "Billing Code",
      "days_to_cancel": "Days to cancel",
      "autocancel": "Auto cancellation",
      "external_code": "External code",
      "vat_active": "Vat active",
      "gmx_contract_id": "GMX Contract Id",
      "paste_json": "Enter JSON",
      "select_default_json": "Default JSON",
      "write_json_manually": "Write JSON manually",
      "json": "JSON",
      "invalid_json": "The JSON entered is not valid",
      "invalid_formulas": "The entered formulas are not valid",
      "tableName": "tableName",
      "api_endpoint": "Api Endpoint",
      "parent_workunit": "Work Unit - Parent",
      "parent_businessunit": "Business Unit - Parent",
      "path": "path",
      "main": "Main",
      "mapping": "Mapping",
      "settings": "Settings",
      "fiscal_data": "Fiscal Data",
      "is_agency": "Agency",
      "destination": "Destination",
      "destination_detail": "Destination detail",
      "datetime_destination": "Destination date and time",
      "parent_businessRule": "Business Rule - Parent",
      "rule_type": "Rule type",
      "rule_liquidation_type": "Liquidation rule type",
      "destination_type": "Destination type",
      "source": "Source",
      "payment": "Payment",
      "journal_entry": "Journal Entry",
      "journal_entry_date": "Journal entry date",
      "provision": "Provision",
      "provision_date": "Provision date",
      "payments": "Payments",
      "payment_types": "Payment types",
      "payment_methods": "Payment methods",
      "payment_type": "Payment type",
      "payment_method": "Payment method Card",
      "payment_method_by_bank": "Bank Payment Method",
      "no_selected_var": "No variables selected",
      "operators": "Operators",
      "data": "Data",
      "variables": "Variables",
      "create_formula": "Create formula",
      "formula": "Formula",
      "show_breakdown": "Show in breakdown",
      "show_sitio": "Show on site",
      "show_breakdown_and_sitio": "Show in breakdown and on site",
      "flexi": "Flexi",
      "extra_baggage": "Extra Baggage",
      "checkin": "Check-in",
      "checkout": "Check-out",
      "concept": "Concept",
      "amounts": "Amounts",
      "amount": "Amount",
      "amount_pending": "Pending Amount",
      "id_item": "Item Id",
      "id_reserva": "Reservation Id",
      "booking_number": "Booking number",
      "item_number": "Item number",
      "amount_to_pay": "Amount to pay",
      "date_time": "Date",
      "auth_code": "Authorization",
      "card_number": "Card number",
      "expiry_date": "Expiration date",
      "cardholder": "Cardholder",
      "card_holder": "Cardholder",
      "issuing_bank": "Issuing bank",
      "quota": "Installment count",
      "client_document_number": "Client document number",
      "client_name": "Client name",
      "bank": "Bank",
      "destinationBank": "Destination bank",
      "issuingBank": "Issuing bank",
      "cash": "Cash",
      "type": "Type",
      "number": "Number",
      "initial_date": "Initial date",
      "final_date": "End date",
      "bank_name": "Bank",
      "refundable": "Refundable",
      "route": "Route",
      "reference": "Reference",
      "gateway": "Payment gateway",
      "version_number": "Version Number",
      "modify_by": "Modified by",
      "slug": "Slug",
      "account_number": "Account number",
      "parent_id": "Parent Id",
      "type_sum": "Sum",
      "financial_entity": "Financial entity",
      "card": "Card",
      "last_digit_card": "Last 4 digits",
      "reservation_item": "reservation items",
      "passenger": "Passenger",
      "titular_passenger": "Holder passenger",
      "managerResponsible": "Operational Responsible",
      "operations": "Operations",
      "operations_vietur": "Operations Vietur",
      "operation_type": "Operation type",
      "amount_to_use": "Amount to use",
      "reserve": "Reservation",
      "document": "Document",
      "age": "Age",
      "birth_date": "Date of birth",
      "is_titular": "Is holder?",
      "extra": "extra",
      "external_id": "External ID",
      "gds": "GDS",
      "id_issue_office": "Issuing office Id",
      "transmitter": "transmitter",
      "carryOnWeight": "CarryOn Weight",
      "handbag": "handbag",
      "unit": "Unit",
      "weight": "Weight",
      "operator_company": "Operating company",
      "booking_class": "Class",
      "flight": "Flight",
      "fare_basis": "Fare basis",
      "equipmentType": "Equipment",
      "Cabin": "Cabin",
      "provider": "Provider",
      "provider_code": "Provider code",
      "distribution": "Distribution",
      "type_room": "Room type",
      "regime": "Regime",
      "coverage": "Coverage",
      "driver_name": "Driver's name",
      "driver_lastname": "Driver's last name",
      "driver_document": "Driver's document",
      "driver_age": "Driver's age",
      "car_name": "Car name",
      "assistance_name": "Assistance name",
      "origin": "Origin",
      "origin_detail": "Origin detail",
      "datetime_origin": "Origin date and time",
      "operatingCarrier": "Operating Carrier",
      "marketingCarrier": "Marketing Carrier",
      "marketingInformation": "Marketing Information",
      "business_name": "Business name",
      "point_of_sale": "Point of sale",
      "segment_price": "Segment rate",
      "booking_reference": "Booking Reference",
      "hold_distributor": "Expiration Date",
      "hash": "Hash",
      "priority": "Priority",
      "active_hours_to": "End of activation hour ",
      "active_hours_from": "Start of activation hour",
      "active_days": "Active days",
      "start_reservation_date": "Purchase date from",
      "end_reservation_date": "Purchase date until",
      "start_service_date": "Start date of service from",
      "end_service_date": "Start date of service until",
      "numbering_client": "Client Numbering",
      "numbering_reservation": "Reservation Numbering",
      "file_number": "File number",
      "number_items": "Item number",
      "total": "Total",
      "num_item_billing": "Billing Item Number",
      "invoice": "Invoice",
      "nro": "Nro",
      "invoice_id": "Invoice id",
      "change_type": "Exchange type",
      "change_type_reversed": "Reverse exchange type",
      "receipt_number": "Receipt Number",
      "cash_name": "Cash",
      "client_document_type": "Document type",
      "origin_date": "Date",
      "vendor_code": "Credit card",
      "transaction": "Transaction",
      "comision": "Commission",
      "commission_paid": "Assigned Commission",
      "expenses": "Administrative Expenses",
      "fare_amount": "Rate amount",
      "fee": "Fee",
      "final_price": "Sale price",
      "iva": "Iva",
      "neto_factura": "Net Invoice",
      "total_factura": "Total Invoice",
      "neto_gravado_10_5": "Taxable Net Amount (10,5% VAT)",
      "base_rg5617": "RG 5617 Taxable Base",
      "neto_exento": "Exempt Net Amount",
      "neto_gravado_21": "Taxable Net Amount (21% VAT)",
      "neto_no_gravado": "Non-Taxable Net Amount",
      "neto_iva_no_corresponde": "Net Amount (VAT Not Applicable)",
      "impuesto1": "Taxes 1",
      "markup": "Markup",
      "mark_up": "Markup",
      "optmzd_mrkup_amnt": "Optimization",
      "net_agency": "Net Price Agency",
      "net_price": "Net price",
      "net_provider": "Net provider",
      "over_amount": "Over",
      "taxes_amount": "Taxes",
      "product_type": "Product type",
      "renter": "Renter",
      "date_origin_service": "Start of service",
      "date_destination_service": "End of service",
      "pickup_origin": "Origin",
      "pickup_date": "Date and Time",
      "pickup_type": "Pick Up Detail",
      "pickup_destination": "Destination",
      "pickup_transfer_type": "Transfer Type",
      "pickup_category": "Category",
      "pickup_vehicle": "Vehicle Type",
      "pnr": "PNR code",
      "days_number": "Number of days",
      "donwload_voucher": "Download voucher",
      "commissionable_rate": "Commissionable rate",
      "non_commissionable_rate": "Non-commissionable rate",
      "commission_percentage": "Commission percentage",
      "ancillary_pax_1": "Cost ancillary baggage",
      "additional_fare": "Additional payable at destination",
      "net_price_by_car": "Total provider cost",
      "nationality": "Nationality",
      "residence_country": "Country of residence",
      "receiver": "Receiver",
      "mail": "Email",
      "hashuser": "User hash",
      "hash_business_unit": "Business unit hash",
      "agency_id": "Agency Id",
      "pick_up": "Pick Up",
      "drop_off": "Drop Off",
      "check_in_pick_up": "Pick Up Date",
      "check_in_drop_off": "Drop Off Date",
      "dropoff_type": "Drop Off Detail",
      "created_at": "Creation date",
      "reservation_number": "Reservation number",
      "service_detail": "Service detail",
      "date_first_service": "First service date",
      "start_date_first_service": "First service date from",
      "end_date_first_service": "First service date until",
      "start_create_date": "Creation date from",
      "end_create_date": "Creation date until",
      "start_autocancel_date": "Auto cancel date from",
      "end_autocancel_date": "Auto cancel date until",
      "start_last_modification_date": "Modification date from",
      "end_last_modification_date": "Modification date until",
      "search_client": "Search client",
      "search_reservation": "Search reservation",
      "add_tags": "Add tags to the product",
      "round_trip": "Pick up and drop off at the same place",
      "add_transfer": "Add transfer?",
      "detail_service": "Service detail",
      "hash_booking_id": "Hash/Booking ID",
      "product-type": "Product type",
      "product-types": "Product types",
      "validity": "Validity",
      "from": "From",
      "to": "To",
      "rate_type": "Rate type",
      "ticketNumber": "Pass number",
      "period_type": "Offer type",
      "duration": "Duration",
      "sample": "Sample",
      "offline_product": "Supports Offline load",
      "prefix": "Prefix",
      "document_branch_number": "Branch number",
      "last_used": "Last used",
      "payment_status": "Payment status",
      "reservation_status": "Reservation status",
      "item_status": "Each item status",
      "num_pax": "Number of passengers",
      "num_segments": "Number of segments",
      "seat": "Seats",
      "create_time": "Creation date",
      "paypal_id": "Paypal Id",
      "payment_id": "Payment Id",
      "intent": "Reason",
      "observation": "Observation",
      "origin_observation": "Origin observation",
      "currency_to": "Currency to",
      "currency_from": "Currency from",
      "available_credits": "Available credits",
      "credit_to_sum": "Credits to add",
      "limit_credit": "Credit limit",
      "has_credit": "Uses credits",
      "gmx_segment_id": "Gimmonix Code",
      "is_berlin": "Is berlin?",
      "setting_email": "Email settings",
      "logo": "Logo",
      "logo_voucher": "Voucher logo",
      "sale_number": "External Reference",
      "autocancel_date": "Auto cancel date",
      "primary_color": "Primary color",
      "secondary_color": "Secondary color",
      "folder_root": "Root folder",
      "bcc_email": "BCC email",
      "transport": "Transport",
      "mailer_from": "Mailer from",
      "mailer_host": "Mailer host",
      "mailer_user": "Mailer user",
      "mailer_password": "Mailer password",
      "mailer_port": "Mailer port",
      "use_tls": "Use tls",
      "use_ssl": "Use ssl",
      "header": "Header",
      "subject": "Subject",
      "greeting": "Greeting",
      "content": "Content",
      "footer": "Footer",
      "hash_value": "Hash",
      "notification": "Notifications",
      "seller_user": "Seller user",
      "last_update_date": "Last update date",
      "tma_business": "TMA Business",
      "tags": "Tags",
      "folder": "Folder",
      "billing_status": "Billing status",
      "billing_situation": "Billing situation",
      "billing_situation_yes": "Billed",
      "billing_situation_no": "Not Billed",
      "additional_cost": "Additional cost",
      "total_cost": "Total Cost",
      "current_password": "Current password",
      "new_password": "New password",
      "confirm_new_password": "Confirm new password",
      "credit_or_payment_type": "Credit or Payment type",
      "apply_extra_cost": "Applies Expenses",
      "amount_in_currency_to_pay": "Total in source currency",
      "currency_pay": "Payment currency",
      "total_amount_in_currency_to_pay": "Total in payment currency",
      "pending_amount_in_currency_to_pay": "Pending in payment currency",
      "amount_to_apply": "Amount to apply",
      "total_amount_billing": "Total Sale",
      "total_cost_billing": "Total Cost",
      "base": "Exchange rate",
      "profit_percentage": "% Profit",
      "item_descripcion": "Item Description",
      "amount_paid": "Amount Paid",
      "pending_amount": "Pending payment",
      "have_credit": "Has credit",
      "amount_unused": "Amount unused",
      "e_ticket": "E-Ticket",
      "in_reserve": "In reserve",
      "marketing_carrier": "Marketing carrier",
      "addressee": "Addressee",
      "email_sent": "Email sent",
      "send_to": "Send to",
      "differentiated_change_type": "Differentiated exchange type",
      "invoice_reference": "Invoice reference",
      "receipt_reference": "Receipt reference",
      "search_by": "Search by:",
      "type_of_service": "Type of Service",
      "condition": "Condition",
      "billing_base": "Billing Base",
      "billing_default_base": "Default Billing Base",
      "billing_alternate_base": "Alternate Billing Base(s)",
      "start_billing_date": "Start Billing Date",
      "end_billing_date": "End Billing Date",
      "billing_date": "Billing Date",
      "start_invoice_date": "Start Invoice Date",
      "end_invoice_date": "End Invoice Date",
      "invoice_date": "Invoice Date",
      "ticket_number": "Ticket number",
      "is_billable": "Ready to bill",
      "auto_bill": "Auto bill",
      "final_sale": "Total sale",
      "size_width": "Size width (px)",
      "size_height": "Size height (px)",
      "mobile_size_width": "Mobile size width (px)",
      "mobile_size_height": "Mobile size height (px)",
      "title": "Title",
      "button_text": "Button text",
      "link_button": "Button link",
      "group": "Group",
      "html_content_additional": "Additional HTML content",
      "meta": "Meta",
      "link": "Link",
      "datetime_from": "Date from",
      "datetime_to": "Date until",
      "html_content": "HTML Content",
      "flow": "Flow",
      "order": "Order",
      "site_type": "Site type",
      "category": "Category",
      "banner_type": "Banner type",
      "image": "Image",
      "mobile_image": "Mobile image",
      "banner": "Banner",
      "label": "Label",
      "caption": "Caption",
      "url": "URL",
      "base_to_billing": "Base for billing",
      "menu_visible": "Menu visible",
      "form_visible": "Form visible",
      "newsletter_visible": "Newsletter visible",
      "default_form": "Default form",
      "sector_type": "Sector type",
      "banners": "Banners",
      "sector": "Sector",
      "html": "HTML",
      "setting_html": "Configure HTML",
      "see_html": "See HTML",
      "billing": "Billing",
      "landing": "Landing",
      "auto_billable": "Automatic billing",
      "amount_compensated": "Amount to compensate in %{currency}",
      "amount_pending_in": "Pending Amount in %{currency}",
      "amount_pending_to_pay_in": "Pending Amount to pay in %{currency}",
      "liquidation_type": "Liquidation type",
      "login_required": "Login required",
      "index_required": "Index",
      "payment_date": "Payment Date",
      "apply_total_in_order": "Apply by order",
      "apply_total_equitably": "Apply equitably",
      "work_unit_long_name": "Work unit long name",
      "work_unit_short_name": "Work unit short name",
      "billing_automatic": "Automatic billing",
      "create_at_date": "Creation Date",
      "formula_global_variables": "Global variables",
      "textColor": "Text Color",
      "backgroundColor": "Background Color",
      "ticket_type": "ticket type",
      "check_type": "Type of check",
      "is_emd": "Is EMD",
      "sale_discount": "Sale discount",
      "taxes_1": "Tax 1",
      "taxes_2": "Tax 2",
      "taxes_3": "Tax 3",
      "cabotage": "Cabotage",
      "fare_code": "Additional Rate",
      "method_pay_uatp": "UATP",
      "complete_client_name": "Full name of the cardholder",
      "agency_auth_code": "Authorization",
      "payment_id_braspag": "Braspag Identifier",
      "braspag_id": "Braspag Identifier",
      "card_brand_id": "Card Brand Identifier",
      "customer_email": "Customer Email",
      "customer_birth": "Customer Birth Date",
      "customer_street": "Customer Address",
      "customer_city": "Customer City",
      "customer_district": "Customer District",
      "child": "Child",
      "adult": "Adult",
      "infant": "Infant",
      "due_date_final": "Extended date",
      "start_due_date": "Payment Due Date From",
      "end_due_date": "Payment Due Date To",
      "due_date": "Payment Due Date",
      "accounting_date": "Accounting date",
      "days": "Days",
      "due-date-range": "Payment Due Date",
      "date_ranges": "Date range",
      "holder": "Holder",
      "passenger_type": "Passenger type",
      "paypal_create_time": "Creation date",
      "exclude_product": "Exclude product",
      "applications": "Applications",
      "price_logic": "Price logic",
      "json_product": "PRODUCT JSON",
      "detail_table": "DETAILS TABLE",
      "language": "Language",
      "due_date_method": "Due Date Model",
      "expirations": "Expirations",
      "determining_date": "Determining Date",
      "application_date": "Application Date",
      "customer_number": "House Number",
      "customer_state": "Customer State",
      "customer_country": "Customer Country",
      "customer_zip_code": "Customer Zip Code",
      "customer_complement": "Customer Complement",
      "installments": "Installments",
      "card_brand_name": "Card",
      "ref_site": "Reference for the site",
      "item_billing_status": "Billing status of the item",
      "status_fraud": "Fraud Analysis",
      "my_device_computer": "computer",
      "my_device_phone": "phone",
      "browser": "Browser",
      "last_active": "Last active",
      "unknown": "Unknown",
      "tx_id": "Transaction",
      "order_id": "Order ID",
      "customer_document_type": "Document type",
      "customer_document_value": "Document value",
      "customer_name": "Name",
      "has_retention": "Has Retention",
      "retention_type": "Type of Retention",
      "retention_amount": "Retention Amount",
      "retention_certificate": "Certificate Number",
      "amount_used": "Amount used",
      "payer_CUITCUIL": "Payers CUIT/CUIL",
      "reservationNumber": "Reservation No.",
      "removeReservation": "Remove",
      "totalAmount": "Total amount",
      "paidAmount": "Paid amount",
      "pendingAmount": "Pending amount",
      "paymentMethod": "Payment method",
      "otherAmount": "Other amount",
      "declaredTotal": "Declared total",
      "selectedTotal": "Selected total",
      "finalBalance": "Final balance",
      "supplierCode": "Supplier code",
      "month": "Month",
      "currencyType": "Currency type",
      "isInherited": "Is inherited",
      "allocation_message": "Allocation message",
      "operation_id": "Operation ID",
      "journal_id": "Journal ID",
      "journal": "Journal",
      "hepstar_status": "Hepstar Status",
      "hepstar_code": "Hepstar Code",
      "hepstar_product": "Hepstar Product",
      "hepstar_product_airhelp": "AirHelp Compensation",
      "hepstar_product_cfar": "Cancel For Any Reason",
      "hepstar_product_refundable": "Cancel For Specific Reasons",
      "hepstar_product_smartdelay": "SmartDelay",
      "hepstar_product_traceme": "Luggage Loss Protection",
      "hepstar_product_esim": "eSIM",
      "general_state": "General State",
      "flow_status": "Flow Status",
      "company": "Company",
      "commerce_number": "Commerce Number",
      "display": "Display",
      "terminal": "Terminal",
      "client_code": "Client code",
      "pyment_attempts": "Payment attempts",
      "error_detail": "Error detail",
      "payment_detail": "Payment detail",
      "error_code": "Error code",
      "session_expired": "Session expired",
      "fraud_id": "Fraud ID",
      "emission_status": "Emission status",
      "abandon_instance": "Abandon instance",
      "fraud_detail": "Fraud detail",
      "route_type": "Route type",
      "device": "Device",
      "start_validity": "Start Validity",
      "end_validity": "End Validity",
      "last_update": "Last update",
      "coef": "Coefficient",
      "card_type": "Card type",
      "include_route": "Included routes",
      "exclude_route": "Excluded routes",
      "exclude_airlines": "Excluded airlines",
      "only_airline": "Unique airline",
      "business": "Business",
      "site_label": "Site label",
      "seat_selection": "Seat selection",
      "food": "Food",
      "changes": "Changes",
      "refoundable": "Refound",
      "all_devices": "Devices",
      "meta_code": "Meta code",
      "meta_info": "Metadata",
      "medium": "Medium",
      "campaign": "Campaign",
      "sessid": "Sessid",
      "tcid": "Tcid",
      "term": "Term",
      "comments": "Comments",
      "message": "Message",
      "amount_refunded": "Refund penalty",
      "accounting_config_code": "Accounting configuration",
      "supplier_type": "Supplier type",
      "creation_user": "Creation user",
      "assigned": "Assigned",
      "message_type": "Message type",
      "for": "For",
      "follower": "Follower",
      "assign_item": "Assign item",
      "task_role": "Task role",
      "template": "Template",
      "total_to_return": "Amount to return",
      "smartbookTitle": "Smartbook",
      "smartbookOriginalProvider": "Original provider",
      "smartbookJson": "Smartbook JSON",
      "reserve_nrf": "Reserve Non Ref",
      "documents": "Documents",
      "charged": "Charged",
      "credit_balance": "Credit balance",
      "billable_exchange_rate": "Billable exchange rate",
      "retention": "Retention",
      "bad_practice": "Bad practices",
      "debit": "Debit",
      "transaction_date": "Transaction date",
      "parent_long_name": "Parent Long Name",
      "parent_short_name": "Parent Short Name",
      "parent_fiscal_data_name": "Parent Fiscal Data Name",
      "online_payments": "Online payments",
      "add_payment_instance": "Add payment instance",
      "weekly_availability": "Weekly availability",
      "supplier_due_date": "Supplier due date",
      "aditional_recipients": "Aditional recipients",
      "creator": "Creator",
      "internal_code": "Internal code",
      "subtype": "Subtype",
      "date_type": "Date type",
      "sending_frequency": "Sending frecuency",
      "analysis_period": "Analysis period",
      "payment_due_date": "Payment due date",
      "first_service_date": "Date of 1st service",
      "recipients": "Recipients",
      "frequency": "Frequency",
      "frequencies": "Frequencies",
      "flexi_amnt": "Flexible Amount",
      "item_create_date": "Item creation date",
      "reserve_create_date": "Reservation creation date",
      "custom": "Custom",
      "overdue_balance": "Overdue balance",
      "balance_due": "Due balance",
      "item_ticket_number": "Air ticket number",
      "gateway_expenses": "Gateway expenses",
      "end_date": "End date",
      "receipt_generated": "Receipt generated",
      "form": "Form",
      "interest_display": "Interest display",
      "fraud_review": "Fraud Revision",
      "rebooker": "Rebooker",
      "disable_rebooker": "Disabled rebooker",
      "days_to_rebook": "days to rebook",
      "markup_additional": "Additional markup",
      "currency_value": "Currency value",
      "type_determination_date": "Determining date type",
      "hepstar": "Hepstar",
      "start_date": "Start date",
      "debit_note": "Debit note",
      "credit_note": "Credit note",
      "voucher_date": "Voucher date",
      "tour_id": "Tour ID",
      "aditional_information": "Itinerary details",
      "day": "Day",
      "cities": "Cities",
      "optional_services": "Optional services",
      "optional": "Optional",
      "quantity": "Quantity",
      "price": "Price",
      "tax": "Tax",
      "operator": "Tour operator",
      "start_city": "Start city",
      "end_city": "End city",
      "included": "Include",
      "not_included": "Not include",
      "provided_hotels": "Provided hotels or similars",
      "detail": "Detail",
      "created_log": "Log create date",
      "kid_age": "Kid's age",
      "kid_weight": "Kid's weight",
      "Only_hand_bags?": "Only hand's bags",
      "supplier_expense_date": "Supplier Expense Entry Date",
      "has_receipt": "Has receipt",
      "is_conciliable": "Conciliable",
      "is_private": "Private",
      "no_conciled": "No reconciled",
      "passenger_count": "Passenger count",
      "expiration_date": "Passport Expiration Date",
      "support_reason": "Support reason",
      "resolution": "Resolution",
      "exclusive_use": "Exclusive use Technology",
      "timezone": "Timezone",
      "commercial_terms": "Commercial terms",
      "product_line": "Product line",
      "nrf_book": "Non Ref reservation",
      "show_supplier": "Show supplier",
      "pw_action_travel": "Action Travel",
      "tma": "TMA",
      "REDMINE": "Redmine",
      "redmine_superadmin": "Redmine Superadmin",
      "fiscal_address": "Tax address",
      "total_price": "Total price",
      "total_passengers": "Total passengers",
      "payment_policy": "Payment policy",
      "billing_code": "Billing code",
      "item_currency": "Invoice currency",
      "invoice_currency": "Item currency",
      "retail": "Retail",
      "wholesaler": "Wholesaler",
      "global_variable": "Global variable",
      "show_breakdown_global_variable": "Show global variable in breakdown",
      "rule_short": "Rl.",
      "rule_price_short": "Price Rl.",
      "fiscal_number": "Fiscal number",
      "number_journal_entry": "Journal entry number",
      "login": "Login",
      "file": "File",
      "exchange_b2": "Rate B2",
      "exchange_invoice": "Rate invoice",
      "promo": "Promo",
      "promotion": "Promotions",
      "payment_method_filter": "Payment method",
      "payment_select": "Select",
      "days_of_week": "Days of the week",
      "promotion_name": "Promotion Name",
      "site_description": "Site description",
      "apply_coupon": "Apply coupon",
      "coupon_code": "Coupon code",
      "total_quantity": "Total quantity",
      "required_services": "Required services (optional)",
      "application_value": "Application value",
      "product_type_aereos": "Flights",
      "product_type_asistencia": "Assistance",
      "product_type_autos": "Cars",
      "product_type_hoteles": "Hotels",
      "product_type_trenes": "Trains",
      "service_flexible": "Flexible",
      "service_branded_fare": "Branded Fare",
      "service_extra_baggage": "Extra Baggage",
      "service_hepstar": "Hepstar",
      "service_premium_package": "Premium Package",
      "application_base_fare": "Base Fare",
      "application_base_fare_taxes": "Base Fare + Taxes",
      "application_base_fare_taxes_charges": "Base Fare + Taxes + Charges",
      "application_total_amount": "Total Amount",
      "application_flexi": "Flexi",
      "application_service_package": "Premium Package",
      "range_currency": "Range currency",
      "ranges": "Ranges",
      "discount": "Discount",
      "cap": "Cap",
      "add_range": "Add range",
      "fixed_amount": "Fixed amount",
      "percentage": "Percentage",
      "validity_start": "Validity Start",
      "validity_end": "Validity End",
      "service_start_from": "Service start from (optional)",
      "service_end_to": "Service end to (optional)",
      "site_currency": "Site currency",
      "payment_method_optional": "Payment method (optional)",
      "promotion_conditions": "Promotion conditions (optional)",
      "all": "All",
      "credit_card": "Credit card",
      "debit_card": "Debit card",
      "debin": "Debin",
      "deposit": "Deposit",
      "transfer": "Transfer",
      "redirect_url_placeholder": "Enter the redirect URL",
      "validity_from": "Valid From",
      "validity_to": "Valid To",
      "uses": "Uses",
      "stock_total": "Total Stock",
      "promo_1": "Promo discount 1",
      "promo_2": "Promo discount 2",
      "customer_info": "Customer data",
      "customer_province": "Province",
      "installments_gateway": "Gateway installments",
      "session_closed": "Session closed",
      "expense": "Expense",
      "unifyCoef": "Unify Coefficient",
      "bines": "Bines",
      "cft": "Total Financial Cost",
      "tea": "Annual Effective Rate",
      "refund": "Refund",
      "bonus": "Bonus",
      "amount_meta": "Meta Fee",
      "availability": "Availability",
      "purchase_code": "Purchase code",
      "amount_earned": "Amount earned"
    },
    "backend_error": {
      "not_credit": "for Insufficient Credit"
    },
    "tooltip": {
      "change_status_to_cancel": "This action will only change the status to canceled",
      "change_status_to_invoiced": "This action will only change the status to issued",
      "separateReservationsForMultiSearch": "Separate the reservations by commas for multi-search",
      "gateway_installment": "Gateway through which payment will be processed to the company",
      "site_label_installment": "Used to reflect information related to the financing of the site",
      "order_installment": "Prioritizing on-site financing",
      "routes_installment": "Used for financing applicable only for specific routes. Use IATA codes separated from each other by a hyphen and a comma without a space when there is more than one. Example: EZE-MAD,MAD-EZE",
      "exclude_airlines_installment": "Used to exclude specific airline codes that do not apply for financing",
      "only_airline_installment": "Activate option when financing applies only to flights operated by the airline indicated in the \"Company\" field",
      "installments": "Amount of installments displayed on the site.",
      "installments_gateway": "Amount of installments for processing in the payment gateway.",
      "coef_installment": "The cost resulting from the application of this coefficient is passed on to the customer on site.",
      "expense_installment": "Field used to calculate the internal cost of financing, whether or not it is passed on to the customer.",
      "unify_coef_installment": "If the cost of financing is activated, it will be shown on the unified site under Charges, otherwise it will be broken down in a separate line under Interest in the price detail.",
      "bines_installment": "In the event that the financing applies only to certain goods, indicate this in this section, separated by commas without spaces.",
      "cft_installment": "Free text. Info to display on the site.",
      "tea_installment": "Free text. Info to display on the site.",
      "refund_installment": "Free text. Info to display on the site.",
      "promotion_name": "Free text field that allows you to identify the promotion within the promotion list.",
      "site_description": "Legend that will be displayed in the shopping cart to show the discount when the coupon/promo is applied on the site.",
      "apply_coupon": "If activated, this indicates that the promotion is a COUPON itself and must be inserted on the site for the discount to be applied. Additionally, it will require indicating the Coupon Code you wish to create and the Original Total Quantity available. If this last field is left empty, the stock for its use is considered unlimited, otherwise complete with the desired total.",
      "work_unit": "Work Unit for which the promotion applies. If you wish to choose more than one Work Unit, only those that are at the same hierarchical level can be selected. It is not possible to combine Parent Work Units with Child Work Units, for this it will be necessary to create an additional promotion.",
      "product_type": "Main online product to which the promotion applies",
      "airline_code": "If you want to create a promotion valid only for flights of one or more airlines, select them from the list; otherwise it will apply to all of them.",
      "destination_type": "If you want to create a promotion valid only for \"Domestic\" or \"International\" flights, select the desired option from the list; otherwise it will apply to all of them.",
      "required_services": "If you want to determine the selection of a service as mandatory for the application of the promotion, it must be selected from the list; otherwise the system does not validate the selection of the additional service. This defines the messaging displayed on the site to guide the customer that they must add said service for the discount to apply.",
      "application_value": "Refers to the value on which the benefit will be applied.",
      "discount_ranges": "In this section the discount application range(s) are defined. It will be necessary to first enter the Range Currency, which defines the currency of the values indicated in the ranges. There is no limit to the creation of ranges. If the promotion is to be applied without a minimum, enter 0 in the From field of the first range. Use the To field to define the maximum of the range. Use the Type field to indicate if the discount to be granted is a fixed amount or a percentage and enter the amount in the Discount field to define it. You can use the Cap field in case you want to limit the resulting discount offered if its calculation is percentage.",
      "validity_start": "Select the start date of the Promotion.",
      "validity_end": "Select the end date of the Promotion.",
      "starts_at": "Field available to indicate that the promotion only applies to services that start from a certain date.",
      "ends_at": "Field available to indicate that the promotion only applies to services that end before a certain date.",
      "site_currency": "Allows you to limit the application of the promotion to a certain currency in the online flow. Important: If a \"Domestic\" Destination Type is chosen, the only currency available will be ARS in the case of sites in Argentina.",
      "payment_method": "Allows you to specify the payment method(s) for which the discount will apply. Do not complete if you want the discount to apply to all payment methods.",
      "terms_and_conditions": "Optional free text field to specify URL that redirects to the promotion conditions. This field is a link to associate the promotion created through B2 with the terms and conditions specified by Marketing."
    },
    "language": {
      "english": "English",
      "spanish": "Spanish",
      "pt_br": "Portuguese (Brazil)"
    },
    "rule_type": {
      "PRICE": "Price Rule",
      "LIQUIDATION": "Liquidation Rule",
      "BILLING": "Billing Rule",
      "PAYMENT_CHARGE": "Payment Charge Rule",
      "SETTING": "Configuration Rule",
      "CONTENT": "Content Rule",
      "PAYMENT_METHOD": "Payment Methods Rule",
      "INSTALLMENT": "Financing Rule"
    },
    "destination_type": {
      "all": "All",
      "national": "National",
      "international": "International"
    },
    "card_type": {
      "credito": "Credit",
      "debito": "Debit"
    },
    "baggage_type": {
      "small_baggage_title": "Includes a backpack or purse",
      "small_baggage_description": "It should fit under the front seat.",
      "medium_baggage_title": "Includes hand luggage",
      "medium_baggage_description": "It must fit in the overhead compartment of the plane.",
      "medium_baggage_not_included": "Does not include hand luggage",
      "large_baggage_not_included": "Does not include checked baggage",
      "large_baggage_included": "Includes checked baggage"
    },
    "legend": {
      "show_sitio": "Visible on site",
      "show_breakdown": "Visible in the breakdown",
      "show_global_variable": "Global variable not visible",
      "show_breakdown_and_sitio": "Visible in breakdown and on the site",
      "show_breakdown_global_variable": "Visible global variable",
      "show_liquidation_retail": "Visible in Retail Liquidation",
      "show_liquidation_wholesaler": "Visible in Wholesale Liquidation",
      "show_liquidation_supplier": "Visible in Supplier Liquidation",
      "global_variable_indicator": "Global variable"
    }
  }
}

export default languageEnObj
